

// import React, { useEffect, useState, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// import {
//   Box, Grid, Card, CardContent, Typography, Chip, Stack, Divider,
//   Button, IconButton, Modal, Fade, Backdrop, CircularProgress,
//   Alert, Dialog, DialogContent, DialogActions,
//   useMediaQuery, useTheme,
// } from "@mui/material";
// import { createTheme, ThemeProvider, alpha } from "@mui/material/styles";
// import {
//   ArrowBack as ArrowBackIcon,
//   Refresh as RefreshIcon,
//   Close as CloseIcon,
//   CalendarMonth as CalendarIcon,
//   AccessTime as TimeIcon,
//   Person as PersonIcon,
//   CancelOutlined as CancelIcon,
//   OpenInNew as OpenIcon,
//   EventNote as EventNoteIcon,
//   WarningAmberRounded as WarnIcon,
//   SentimentDissatisfied as EmptyIcon,
//   Save as SaveIcon,
// } from "@mui/icons-material";

// // ─── Google Fonts ───────────────────────────────────────────────────────────────
// const FontLink = () => (
//   <link
//     href="https://fonts.googleapis.com/css2?family=Sora:wght@700;800;900&family=DM+Sans:wght@400;500;600;700&display=swap"
//     rel="stylesheet"
//   />
// );

// // ─── Theme ─────────────────────────────────────────────────────────────────────
// const theme = createTheme({
//   palette: {
//     primary:    { main: "#006D77", light: "#4A9FA8", dark: "#003D45" },
//     secondary:  { main: "#009AA6" },
//     success:    { main: "#16A34A" },
//     warning:    { main: "#D97706" },
//     error:      { main: "#DC2626" },
//     info:       { main: "#007A85" },
//     background: { default: "#EEF4F5", paper: "#FFFFFF" },
//   },
//   typography: {
//     fontFamily: "'DM Sans', sans-serif",
//     h5:  { fontFamily: "'Sora', sans-serif", fontWeight: 900 },
//     h6:  { fontFamily: "'Sora', sans-serif", fontWeight: 800 },
//     button: { fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: "none" },
//   },
//   shape: { borderRadius: 14 },
//   components: {
//     MuiButton: {
//       styleOverrides: { root: { textTransform: "none", fontWeight: 700, borderRadius: 12 } },
//     },
//     MuiChip: {
//       styleOverrides: { root: { fontWeight: 700, fontSize: 11, borderRadius: 20 } },
//     },
//     MuiCard: {
//       styleOverrides: { root: { borderRadius: 16 } },
//     },
//   },
// });

// // ─── Constants ──────────────────────────────────────────────────────────────────
// const API = process.env.REACT_APP_API_BASE_URL;

// const getAuthHeader = () => {
//   const token = localStorage.getItem("token") || sessionStorage.getItem("token");
//   return token ? { Authorization: `Bearer ${token}` } : {};
// };

// const PKG_META = {
//   "pkg-silver":   { label: "Silver",   icon: "🥈", color: "#006D77", bg: "#E6F4F5", gradient: "linear-gradient(135deg, #006D77, #004E56)" },
//   "pkg-gold":     { label: "Gold",     icon: "🥇", color: "#007A85", bg: "#DFF5F7", gradient: "linear-gradient(135deg, #007A85, #005960)" },
//   "pkg-platinum": { label: "Platinum", icon: "💎", color: "#005C65", bg: "#E3F4F5", gradient: "linear-gradient(135deg, #005C65, #003D45)" },
//   "pkg-elite":    { label: "Elite",    icon: "👑", color: "#008A96", bg: "#DAF3F5", gradient: "linear-gradient(135deg, #008A96, #006370)" },
//   "pkg-diabetes": { label: "Diabetes", icon: "🩸", color: "#004E56", bg: "#E6F4F5", gradient: "linear-gradient(135deg, #004E56, #003040)" },
//   "pkg-women":    { label: "Women's",  icon: "🌸", color: "#009AA6", bg: "#D8F3F5", gradient: "linear-gradient(135deg, #009AA6, #007080)" },
// };

// const STATUS_CONFIG = {
//   Pending:   { color: "warning",   icon: "⏳" },
//   Confirmed: { color: "info",      icon: "✅" },
//   Collected: { color: "secondary", icon: "🔬" },
//   Completed: { color: "success",   icon: "🏁" },
//   Cancelled: { color: "error",     icon: "❌" },
// };

// const PAYMENT_CONFIG = {
//   Unpaid:   { color: "warning", variant: "outlined" },
//   Paid:     { color: "success", variant: "filled"   },
//   Refunded: { color: "default", variant: "outlined" },
// };

// const StatusBadge = ({ value }) => {
//   const c = STATUS_CONFIG[value] || { color: "default" };
//   return (
//     <Chip
//       label={`${c.icon ? c.icon + " " : ""}${value}`}
//       color={c.color} size="small"
//       sx={{ fontWeight: 800, fontSize: 11 }}
//     />
//   );
// };

// const PaymentBadge = ({ value }) => {
//   const c = PAYMENT_CONFIG[value] || { color: "default", variant: "outlined" };
//   return <Chip label={value} color={c.color} variant={c.variant} size="small" />;
// };

// // ─── InfoItem ──────────────────────────────────────────────────────────────────
// const InfoItem = ({ label, value }) => (
//   <Box sx={{
//     background: "#F0F9F9", borderRadius: 2, p: "10px 13px",
//     border: "1px solid #C8E8EB", display: "flex", flexDirection: "column", gap: 0.4,
//   }}>
//     <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#4A9FA8", textTransform: "uppercase", letterSpacing: 0.4 }}>
//       {label}
//     </Typography>
//     <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#0F172A", wordBreak: "break-word" }}>
//       {value || "—"}
//     </Typography>
//   </Box>
// );

// // ─── Cancel Dialog ─────────────────────────────────────────────────────────────
// const CancelDialog = ({ booking, onConfirm, onClose, loading }) => (
//   <Dialog open onClose={onClose} maxWidth="xs" fullWidth
//     PaperProps={{ sx: { borderRadius: 4, p: 1 } }}>
//     <DialogContent sx={{ textAlign: "center", pt: 4, pb: 2 }}>
//       <Box sx={{
//         width: 64, height: 64, borderRadius: "50%",
//         background: "#FEF3C7", border: "2px solid #FDE68A",
//         display: "flex", alignItems: "center", justifyContent: "center",
//         mx: "auto", mb: 2,
//       }}>
//         <WarnIcon sx={{ fontSize: 32, color: "#D97706" }} />
//       </Box>
//       <Typography variant="h6" sx={{ fontWeight: 800, mb: 1, color: "#0F172A" }}>
//         Cancel Booking?
//       </Typography>
//       <Typography sx={{ fontSize: 14, color: "#64748B", mb: 2, lineHeight: 1.7 }}>
//         Are you sure you want to cancel this booking?
//       </Typography>
//       <Box sx={{
//         background: "#E6F4F5", borderRadius: 2.5, py: 1.25, px: 2,
//         fontFamily: "monospace", fontSize: 15, fontWeight: 900, color: "#006D77",
//         border: "1px solid #C8E8EB",
//       }}>
//         {booking.booking_ref}
//       </Box>
//     </DialogContent>
//     <DialogActions sx={{ px: 3, pb: 3, gap: 1.5 }}>
//       <Button fullWidth variant="outlined" onClick={onClose}
//         sx={{ borderColor: "#C8E8EB", color: "#64748B", py: 1.25, borderRadius: 3,
//           "&:hover": { borderColor: "#94A3B8", background: "#F8FAFC" } }}>
//         Keep Booking
//       </Button>
//       <Button fullWidth variant="contained" onClick={() => onConfirm(booking.id)}
//         disabled={loading}
//         startIcon={loading ? <CircularProgress size={14} color="inherit" /> : <CancelIcon />}
//         sx={{
//           background: "#DC2626", py: 1.25, borderRadius: 3, fontWeight: 800,
//           "&:hover": { background: "#B91C1C" },
//           boxShadow: "0 4px 12px rgba(220,38,38,0.3)",
//         }}>
//         {loading ? "Cancelling..." : "Yes, Cancel"}
//       </Button>
//     </DialogActions>
//   </Dialog>
// );

// // ─── Booking Detail Modal ───────────────────────────────────────────────────────
// const BookingDetailModal = ({ booking, onClose, onCancelRequest }) => {
//   const muiTheme  = useTheme();
//   const fullScreen = useMediaQuery(muiTheme.breakpoints.down("sm"));
//   if (!booking) return null;

//   const meta      = PKG_META[booking.package_id] || {};
//   const savings   = booking.savings || (booking.mrp - booking.offer_price);
//   const discPct   = Math.round((savings / booking.mrp) * 100);
//   const canCancel = ["Pending", "Confirmed"].includes(booking.status);

//   return (
//     <Modal open onClose={onClose} closeAfterTransition BackdropComponent={Backdrop}
//       BackdropProps={{ timeout: 300, sx: { backdropFilter: "blur(6px)", backgroundColor: "rgba(0,0,0,0.55)" } }}>
//       <Fade in>
//         <Box sx={{
//           position: "absolute", top: "50%", left: "50%",
//           transform: "translate(-50%, -50%)",
//           width: fullScreen ? "95vw" : 540,
//           maxHeight: "90vh", overflowY: "auto",
//           background: "#fff", borderRadius: 4,
//           boxShadow: "0 32px 80px rgba(0,0,0,0.22)",
//         }}>
//           {/* Gradient Header */}
//           <Box sx={{ background: meta.gradient || "linear-gradient(135deg,#006D77,#003D45)", p: "26px 24px 20px", position: "relative", overflow: "hidden" }}>
//             <Box sx={{ position: "absolute", top: -40, right: -40, width: 160, height: 160, borderRadius: "50%", background: "rgba(255,255,255,0.08)" }} />
//             <Box sx={{ position: "absolute", bottom: -30, left: -20, width: 120, height: 120, borderRadius: "50%", background: "rgba(255,255,255,0.06)" }} />
//             <IconButton onClick={onClose} size="small" sx={{
//               position: "absolute", top: 12, right: 12, zIndex: 2,
//               background: "rgba(255,255,255,0.2)", color: "#fff",
//               "&:hover": { background: "rgba(255,255,255,0.3)" },
//             }}>
//               <CloseIcon fontSize="small" />
//             </IconButton>

//             <Box sx={{ position: "relative", zIndex: 1 }}>
//               <Typography sx={{ fontSize: 34, mb: 0.75, lineHeight: 1 }}>{meta.icon || "📦"}</Typography>
//               <Typography sx={{ color: "#fff", mb: 0.5, fontFamily: "'Sora',sans-serif", fontWeight: 800, fontSize: { xs: 15, sm: 17 } }}>
//                 {booking.package_name}
//               </Typography>
//               <Box sx={{
//                 display: "inline-block", background: "rgba(255,255,255,0.2)",
//                 color: "#fff", fontSize: 12, fontWeight: 900,
//                 px: 1.5, py: 0.4, borderRadius: 2, fontFamily: "monospace", mb: 1.5,
//               }}>
//                 {booking.booking_ref}
//               </Box>

//               <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
//                 <Box>
//                   <Typography sx={{ fontSize: 10, color: "rgba(255,255,255,0.6)", fontWeight: 600, mb: 0.25, textTransform: "uppercase", letterSpacing: 0.5 }}>
//                     Offer Price
//                   </Typography>
//                   <Typography sx={{ fontFamily: "'Sora',sans-serif", fontSize: 26, fontWeight: 900, color: "#80ED99", lineHeight: 1 }}>
//                     ₹{booking.offer_price?.toLocaleString()}
//                   </Typography>
//                 </Box>
//                 <Box sx={{ textAlign: "right" }}>
//                   <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.5)", textDecoration: "line-through" }}>
//                     ₹{booking.mrp?.toLocaleString()}
//                   </Typography>
//                   <Box sx={{
//                     mt: 0.5, background: "rgba(16,185,129,0.2)", border: "1px solid rgba(16,185,129,0.4)",
//                     color: "#80ED99", fontSize: 11, fontWeight: 800, px: 1.25, py: 0.3, borderRadius: 20, display: "inline-block",
//                   }}>
//                     Save ₹{savings?.toLocaleString()} ({discPct}% OFF)
//                   </Box>
//                 </Box>
//               </Box>
//             </Box>
//           </Box>

//           {/* Body */}
//           <Box sx={{ p: { xs: "16px 16px 22px", sm: "18px 22px 26px" } }}>
//             <Stack direction="row" gap={1} mb={2.5} flexWrap="wrap">
//               <StatusBadge value={booking.status} />
//               <PaymentBadge value={booking.payment_status} />
//             </Stack>

//             <Typography sx={{ fontSize: 11, fontWeight: 800, color: "#006D77", textTransform: "uppercase", letterSpacing: 0.5, mb: 1 }}>
//               Appointment
//             </Typography>
//             <Grid container spacing={1} mb={2}>
//               <Grid item xs={6}><InfoItem label="Date"      value={booking.preferred_date} /></Grid>
//               <Grid item xs={6}><InfoItem label="Time Slot" value={booking.preferred_time} /></Grid>
//             </Grid>

//             <Typography sx={{ fontSize: 11, fontWeight: 800, color: "#006D77", textTransform: "uppercase", letterSpacing: 0.5, mb: 1 }}>
//               Patient Details
//             </Typography>
//             <Grid container spacing={1} mb={2}>
//               {[
//                 ["Name",   booking.patient_name],
//                 ["Phone",  booking.phone],
//                 ["Email",  booking.email],
//                 ["Age",    booking.age],
//                 ["Gender", booking.gender],
//               ].map(([l, v]) => (
//                 <Grid item xs={6} key={l}><InfoItem label={l} value={v} /></Grid>
//               ))}
//             </Grid>

//             {booking.address && (
//               <Box mb={2}>
//                 <Typography sx={{ fontSize: 11, fontWeight: 800, color: "#006D77", textTransform: "uppercase", letterSpacing: 0.5, mb: 1 }}>
//                   Address
//                 </Typography>
//                 <InfoItem label="Address" value={booking.address} />
//               </Box>
//             )}

//             {booking.notes && (
//               <Box sx={{ background: "#F0F9F9", border: "1px solid #C8E8EB", borderRadius: 2.5, p: "12px 14px", mb: 2 }}>
//                 <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#4A9FA8", textTransform: "uppercase", letterSpacing: 0.4, mb: 0.5 }}>
//                   Notes
//                 </Typography>
//                 <Typography sx={{ fontSize: 13, color: "#374151", lineHeight: 1.7 }}>{booking.notes}</Typography>
//               </Box>
//             )}

//             {booking.created_at && (
//               <Typography sx={{ fontSize: 11, color: "#94A3B8", textAlign: "center", mb: canCancel ? 1.5 : 0 }}>
//                 Booked on {booking.created_at}
//               </Typography>
//             )}

//             {canCancel && (
//               <Button fullWidth variant="outlined" color="error"
//                 startIcon={<CancelIcon />}
//                 onClick={() => onCancelRequest(booking)}
//                 sx={{
//                   mt: 0.5, py: 1.25, borderRadius: 3, fontWeight: 800, fontSize: 14,
//                   borderColor: "#FECACA", color: "#DC2626",
//                   "&:hover": { background: "#FEE2E2", borderColor: "#EF4444" },
//                 }}>
//                 Cancel This Booking
//               </Button>
//             )}
//           </Box>
//         </Box>
//       </Fade>
//     </Modal>
//   );
// };

// // ─── Booking Card ───────────────────────────────────────────────────────────────
// const BookingCard = ({ booking, onView, onCancelRequest }) => {
//   const meta      = PKG_META[booking.package_id] || {};
//   const savings   = booking.savings || (booking.mrp - booking.offer_price);
//   const canCancel = ["Pending", "Confirmed"].includes(booking.status);

//   return (
//     <Card sx={{
//       display: "flex", overflow: "hidden",
//       border: "1px solid #C8E8EB",
//       boxShadow: "0 2px 12px rgba(0,109,119,0.07)",
//       transition: "all 0.2s",
//       "&:hover": { boxShadow: "0 6px 24px rgba(0,109,119,0.13)", transform: "translateY(-1px)" },
//     }}>
//       {/* Left accent strip */}
//       <Box sx={{ width: 5, background: meta.gradient || "#006D77", flexShrink: 0 }} />

//       <Box sx={{ flex: 1, p: { xs: "14px 14px", sm: "16px 20px" } }}>
//         {/* Top: package info + badges */}
//         <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={1.25} flexWrap="wrap" gap={1}>
//           <Stack direction="row" alignItems="center" gap={1.25}>
//             {/* Package icon tile */}
//             <Box sx={{
//               width: 40, height: 40, borderRadius: 2.5, flexShrink: 0,
//               background: meta.gradient || "#006D77",
//               display: "flex", alignItems: "center", justifyContent: "center",
//               fontSize: 20, lineHeight: 1,
//               boxShadow: "0 3px 10px rgba(0,109,119,0.22)",
//             }}>
//               {meta.icon || "📦"}
//             </Box>
//             <Box>
//               <Typography sx={{
//                 fontFamily: "'Sora',sans-serif",
//                 fontSize: { xs: 13, sm: 14 },
//                 fontWeight: 800, color: "#003D45", lineHeight: 1.3,
//               }}>
//                 {booking.package_name?.replace("Ayuja ", "")}
//               </Typography>
//               <Typography sx={{
//                 fontFamily: "monospace", fontSize: 11, fontWeight: 700,
//                 color: "#006D77", background: "#E6F4F5",
//                 px: 0.75, py: 0.15, borderRadius: 1, display: "inline-block", mt: 0.25,
//               }}>
//                 {booking.booking_ref}
//               </Typography>
//             </Box>
//           </Stack>
//           <Stack direction="row" gap={0.75} flexShrink={0} flexWrap="wrap">
//             <StatusBadge value={booking.status} />
//             <PaymentBadge value={booking.payment_status} />
//           </Stack>
//         </Stack>

//         {/* Appointment info row */}
//         <Stack direction="row" gap={{ xs: 1.5, sm: 2.5 }} flexWrap="wrap" mb={1.25}>
//           {[
//             { icon: <CalendarIcon sx={{ fontSize: 13, color: "#4A9FA8" }} />, text: booking.preferred_date },
//             { icon: <TimeIcon     sx={{ fontSize: 13, color: "#4A9FA8" }} />, text: booking.preferred_time },
//             { icon: <PersonIcon   sx={{ fontSize: 13, color: "#4A9FA8" }} />, text: booking.patient_name  },
//           ].filter(x => x.text).map((item, i) => (
//             <Stack key={i} direction="row" alignItems="center" gap={0.5}>
//               {item.icon}
//               <Typography sx={{ fontSize: 12, color: "#64748B", fontWeight: 600 }}>{item.text}</Typography>
//             </Stack>
//           ))}
//         </Stack>

//         <Divider sx={{ borderColor: "#E6F4F5", mb: 1.25 }} />

//         {/* Price + actions */}
//         <Stack direction="row" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1}>
//           <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap">
//             <Typography sx={{
//               fontFamily: "'Sora',sans-serif",
//               fontSize: { xs: 16, sm: 18 }, fontWeight: 900, color: "#006D77",
//             }}>
//               ₹{booking.offer_price?.toLocaleString()}
//             </Typography>
//             <Typography sx={{ fontSize: 12, color: "#94A3B8", textDecoration: "line-through", fontWeight: 600 }}>
//               ₹{booking.mrp?.toLocaleString()}
//             </Typography>
//             {savings > 0 && (
//               <Chip
//                 label={`Save ₹${savings?.toLocaleString()}`}
//                 size="small"
//                 sx={{ background: "#DCFCE7", color: "#16A34A", fontWeight: 800, fontSize: 10, height: 20 }}
//               />
//             )}
//           </Stack>

//           <Stack direction="row" gap={1}>
//             {canCancel && (
//               <Button size="small" variant="outlined" color="error"
//                 onClick={(e) => { e.stopPropagation(); onCancelRequest(booking); }}
//                 sx={{
//                   borderRadius: 2.5, fontSize: 11, fontWeight: 700,
//                   borderColor: "#FECACA", color: "#DC2626",
//                   "&:hover": { background: "#FEE2E2", borderColor: "#EF4444" },
//                 }}>
//                 Cancel
//               </Button>
//             )}
//             <Button size="small" variant="contained"
//               endIcon={<OpenIcon sx={{ fontSize: 13 }} />}
//               onClick={() => onView(booking)}
//               sx={{
//                 borderRadius: 2.5, fontSize: 11, fontWeight: 800,
//                 background: "linear-gradient(135deg,#006D77,#004E56)",
//                 boxShadow: "0 3px 10px rgba(0,109,119,0.28)",
//                 "&:hover": { background: "linear-gradient(135deg,#007A85,#005960)" },
//               }}>
//               View Details
//             </Button>
//           </Stack>
//         </Stack>
//       </Box>
//     </Card>
//   );
// };

// // ─── Main Page ──────────────────────────────────────────────────────────────────
// const MyPackageBookings = () => {
//   const navigate   = useNavigate();
//   const muiTheme   = useTheme();
//   const isMobile   = useMediaQuery(muiTheme.breakpoints.down("sm"));

//   const [bookings,     setBookings]     = useState([]);
//   const [stats,        setStats]        = useState({});
//   const [loading,      setLoading]      = useState(true);
//   const [error,        setError]        = useState("");
//   const [filterStatus, setFilterStatus] = useState("");
//   const [selectedBook, setSelectedBook] = useState(null);
//   const [cancelTarget, setCancelTarget] = useState(null);
//   const [cancelling,   setCancelling]   = useState(false);

//   const fetchBookings = useCallback(async () => {
//     setLoading(true);
//     setError("");
//     try {
//       const res = await axios.get(`${API}/package-orders/my-bookings`, { headers: getAuthHeader() });
//       if (res.data.success) {
//         setBookings(res.data.bookings || []);
//         setStats(res.data.stats || {});
//       } else {
//         setError(res.data.error || "Failed to load bookings");
//       }
//     } catch (e) {
//       if (e.response?.status === 401) navigate("/login");
//       else setError("Unable to load bookings. Please try again.");
//     }
//     setLoading(false);
//   }, [navigate]);

//   useEffect(() => { fetchBookings(); }, [fetchBookings]);

//   const handleCancel = async (bookingId) => {
//     setCancelling(true);
//     try {
//       const res = await axios.patch(
//         `${API}/package-orders/my-bookings/${bookingId}/cancel`,
//         {},
//         { headers: getAuthHeader() }
//       );
//       if (res.data.success) {
//         setCancelTarget(null);
//         setSelectedBook(null);
//         await fetchBookings();
//       } else {
//         alert(res.data.error || "Cancellation failed");
//       }
//     } catch (e) {
//       alert(e.response?.data?.error || "Cancellation failed");
//     }
//     setCancelling(false);
//   };

//   const filtered = filterStatus
//     ? bookings.filter((b) => b.status === filterStatus)
//     : bookings;

//   const filterTabs = ["", "Pending", "Confirmed", "Collected", "Completed", "Cancelled"];

//   const statCards = [
//     { label: "Total",     val: stats.total     || 0,                               color: "#006D77" },
//     { label: "Pending",   val: stats.pending   || 0,                               color: "#D97706" },
//     { label: "Confirmed", val: stats.confirmed || 0,                               color: "#007A85" },
//     { label: "Completed", val: stats.completed || 0,                               color: "#005C65" },
//     { label: "Savings",   val: `₹${(stats.total_savings || 0).toLocaleString()}`, color: "#009AA6" },
//   ];

//   return (
//     <ThemeProvider theme={theme}>
//       <Box sx={{ minHeight: "100vh", background: "#EEF4F5", fontFamily: "'DM Sans', sans-serif" }}>

//         {/* ── Compact page header — sits BELOW the existing site nav ── */}
//         <Box sx={{
//           background: "linear-gradient(135deg,#003D45 0%,#006D77 100%)",
//           px: { xs: 2, sm: 3, md: 4 },
//           pt: { xs: 2, sm: 2.5 },
//           pb: { xs: 2, sm: 2.5 },
//           position: "relative", overflow: "hidden",
//         }}>
//           {/* Decorative circles */}
//           <Box sx={{ position: "absolute", top: -50, right: -50, width: 180, height: 180, borderRadius: "50%", background: "rgba(255,255,255,0.06)" }} />
//           <Box sx={{ position: "absolute", bottom: -30, left: "30%", width: 120, height: 120, borderRadius: "50%", background: "rgba(255,255,255,0.04)" }} />

//           <Box sx={{ maxWidth: 900, mx: "auto", position: "relative", zIndex: 1 }}>
//             <Stack direction="row" alignItems="center" justifyContent="space-between">
//               {/* Left: back + title */}
//               <Stack direction="row" alignItems="center" gap={2}>
//                 <Button
//                   startIcon={<ArrowBackIcon />}
//                   onClick={() => navigate(-1)}
//                   size="small"
//                   sx={{
//                     color: "#fff", border: "1.5px solid rgba(255,255,255,0.35)",
//                     borderRadius: 50, px: { xs: 1.25, sm: 1 }, py: 1.25, minWidth: 0,
//                     "&:hover": { background: "rgba(255,255,255,0.15)" },
//                   }}>
//                   {/* {!isMobile && "Back"} */}
//                 </Button>
//                 <Box>
//                   <Typography sx={{
//                     fontFamily: "'Sora',sans-serif", fontWeight: 900, color: "#fff",
//                     fontSize: { xs: 16, sm: 20 }, lineHeight: 1.2,
//                   }}>
//                     My Health Bookings
//                   </Typography>
//                   {!isMobile && (
//                     <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.65)", mt: 0.2 }}>
//                       Track and manage your health package appointments
//                     </Typography>
//                   )}
//                 </Box>
//               </Stack>

//               {/* Right: refresh */}
//               <IconButton onClick={fetchBookings} size="small"
//                 sx={{
//                   color: "#fff", background: "rgba(255,255,255,0.15)",
//                   borderRadius: 2.5, border: "1.5px solid rgba(255,255,255,0.25)",
//                   "&:hover": { background: "rgba(255,255,255,0.25)" },
//                 }}>
//                 <RefreshIcon fontSize="small" />
//               </IconButton>
//             </Stack>
//           </Box>
//         </Box>

//         {/* ── Main content area ── */}
//         <Box sx={{ maxWidth: 900, mx: "auto", px: { xs: 1.5, sm: 3 }, py: { xs: 2, sm: 3 }, pb: 6 }}>

//           {/* ── Stats Bar ── */}
//           {!loading && bookings.length > 0 && (
//             <Grid container spacing={{ xs: 1, sm: 1.5 }} mb={2.5}>
//               {statCards.map((s) => (
//                 <Grid item xs={4} sm={4} md={2.4} key={s.label}>
//                   <Card sx={{
//                     textAlign: "center",
//                     border: "1px solid #C8E8EB",
//                     boxShadow: "0 2px 10px rgba(0,109,119,0.08)",
//                     transition: "box-shadow 0.2s",
//                     "&:hover": { boxShadow: "0 6px 20px rgba(0,109,119,0.14)" },
//                   }}>
//                     <CardContent sx={{ p: { xs: "10px 6px !important", sm: "14px 10px !important" } }}>
//                       <Typography sx={{
//                         fontFamily: "'Sora',sans-serif", fontWeight: 900,
//                         color: s.color, fontSize: { xs: 16, sm: 20, md: 22 }, lineHeight: 1,
//                       }}>
//                         {s.val}
//                       </Typography>
//                       <Typography sx={{
//                         fontSize: { xs: 9, sm: 10 }, color: "#4A9FA8",
//                         fontWeight: 700, textTransform: "uppercase", mt: 0.5, letterSpacing: 0.3,
//                       }}>
//                         {s.label}
//                       </Typography>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//               ))}
//             </Grid>
//           )}

//           {/* ── Filter Tabs ── */}
//           {!loading && bookings.length > 0 && (
//             <Stack direction="row" gap={1} flexWrap="wrap" mb={2.5}>
//               {filterTabs.map((s) => {
//                 const count  = s ? bookings.filter((b) => b.status === s).length : bookings.length;
//                 const active = filterStatus === s;
//                 return (
//                   <Button key={s} size="small"
//                     onClick={() => setFilterStatus(s)}
//                     variant={active ? "contained" : "outlined"}
//                     sx={active ? {
//                       background: "linear-gradient(135deg,#003D45,#006D77)",
//                       borderRadius: 20, fontSize: { xs: 11, sm: 12 }, fontWeight: 800,
//                       px: { xs: 1.5, sm: 2 },
//                       boxShadow: "0 3px 10px rgba(0,109,119,0.3)",
//                     } : {
//                       borderColor: "#C8E8EB", color: "#006D77", borderRadius: 20,
//                       fontSize: { xs: 11, sm: 12 }, fontWeight: 700,
//                       px: { xs: 1.5, sm: 2 },
//                       "&:hover": { borderColor: "#006D77", background: alpha("#006D77", 0.05) },
//                     }}>
//                     {s || "All"}{" "}
//                     <Box component="span" sx={{
//                       ml: 0.5, fontSize: 10, fontWeight: 900,
//                       background: active ? "rgba(255,255,255,0.25)" : "#E6F4F5",
//                       color: active ? "#fff" : "#006D77",
//                       px: 0.6, py: 0.1, borderRadius: 8,
//                     }}>
//                       {count}
//                     </Box>
//                   </Button>
//                 );
//               })}
//             </Stack>
//           )}

//           {/* ── Loading ── */}
//           {loading && (
//             <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, py: 10 }}>
//               <CircularProgress sx={{ color: "#006D77" }} size={38} thickness={3} />
//               <Typography sx={{ color: "#4A9FA8", fontWeight: 600, fontSize: 14 }}>
//                 Loading your bookings...
//               </Typography>
//             </Box>
//           )}

//           {/* ── Error ── */}
//           {!loading && error && (
//             <Box sx={{ textAlign: "center", py: 8 }}>
//               <Alert severity="error" sx={{ borderRadius: 3, mb: 2, maxWidth: 420, mx: "auto" }}>{error}</Alert>
//               <Button variant="contained" onClick={fetchBookings}
//                 sx={{ background: "linear-gradient(135deg,#006D77,#003D45)", borderRadius: 3, fontWeight: 800 }}>
//                 Try Again
//               </Button>
//             </Box>
//           )}

//           {/* ── Empty State ── */}
//           {!loading && !error && filtered.length === 0 && (
//             <Box sx={{ textAlign: "center", py: { xs: 8, sm: 10 } }}>
//               <Box sx={{
//                 width: 72, height: 72, borderRadius: "50%",
//                 background: "linear-gradient(135deg,#E6F4F5,#C8E8EB)",
//                 display: "flex", alignItems: "center", justifyContent: "center",
//                 mx: "auto", mb: 2.5,
//               }}>
//                 {filterStatus
//                   ? <EmptyIcon sx={{ fontSize: 36, color: "#4A9FA8" }} />
//                   : <EventNoteIcon sx={{ fontSize: 36, color: "#4A9FA8" }} />
//                 }
//               </Box>
//               <Typography variant="h6" sx={{ color: "#003D45", mb: 1, fontFamily: "'Sora',sans-serif" }}>
//                 {filterStatus ? `No "${filterStatus}" bookings` : "No bookings yet"}
//               </Typography>
//               <Typography sx={{ fontSize: 14, color: "#4A9FA8", mb: 3 }}>
//                 {filterStatus ? "Try a different filter" : "Book a health package to get started"}
//               </Typography>
//               {!filterStatus && (
//                 <Button variant="contained"
//                   endIcon={<OpenIcon />}
//                   onClick={() => navigate("/")}
//                   sx={{
//                     background: "linear-gradient(135deg,#006D77,#003D45)",
//                     borderRadius: 3, fontWeight: 800, px: 3, py: 1.25,
//                     boxShadow: "0 6px 18px rgba(0,109,119,0.3)",
//                     "&:hover": { background: "linear-gradient(135deg,#007A85,#004D55)" },
//                   }}>
//                   Browse Health Packages
//                 </Button>
//               )}
//             </Box>
//           )}

//           {/* ── Booking List ── */}
//           {!loading && !error && filtered.length > 0 && (
//             <Stack gap={2}>
//               {filtered.map((b) => (
//                 <BookingCard
//                   key={b.id}
//                   booking={b}
//                   onView={setSelectedBook}
//                   onCancelRequest={setCancelTarget}
//                 />
//               ))}
//             </Stack>
//           )}
//         </Box>

//         {/* ── Modals ── */}
//         {selectedBook && (
//           <BookingDetailModal
//             booking={selectedBook}
//             onClose={() => setSelectedBook(null)}
//             onCancelRequest={(b) => setCancelTarget(b)}
//           />
//         )}
//         {cancelTarget && (
//           <CancelDialog
//             booking={cancelTarget}
//             onClose={() => setCancelTarget(null)}
//             onConfirm={handleCancel}
//             loading={cancelling}
//           />
//         )}
//       </Box>
//     </ThemeProvider>
//   );
// };

// export default MyPackageBookings;








// import React, { useEffect, useState, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// import {
//   Box, Container, Grid, Card, CardContent, Typography, Chip, Stack, Divider,
//   Button, IconButton, Paper, Modal, Fade, Backdrop, CircularProgress,
//   Alert, Dialog, DialogContent, DialogActions,
//   useMediaQuery, useTheme,
// } from "@mui/material";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
// import {
//   ArrowBack as ArrowBackIcon,
//   Refresh as RefreshIcon,
//   Close as CloseIcon,
//   CalendarMonth as CalendarIcon,
//   AccessTime as TimeIcon,
//   Person as PersonIcon,
//   CancelOutlined as CancelIcon,
//   OpenInNew as OpenIcon,
//   EventNote as EventNoteIcon,
//   WarningAmberRounded as WarnIcon,
//   SentimentDissatisfied as EmptyIcon,
// } from "@mui/icons-material";

// // ─── Theme ──────────────────────────────────────────────────────────────────────
// const theme = createTheme({
//   palette: {
//     primary:    { main: "#006D77", light: "#4A9FA8", dark: "#003D45" },
//     success:    { main: "#16A34A" },
//     warning:    { main: "#D97706" },
//     error:      { main: "#DC2626" },
//     info:       { main: "#007A85" },
//     background: { default: "#F9FAFB", paper: "#FFFFFF" },
//   },
//   typography: {
//     fontFamily: "'DM Sans', sans-serif",
//     h5: { fontFamily: "'Sora', sans-serif", fontWeight: 900 },
//     h6: { fontFamily: "'Sora', sans-serif", fontWeight: 800 },
//     button: { fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: "none" },
//   },
//   shape: { borderRadius: 12 },
//   components: {
//     MuiButton: {
//       styleOverrides: { root: { textTransform: "none", fontWeight: 700 } },
//     },
//   },
// });

// // ─── Constants ──────────────────────────────────────────────────────────────────
// const API = process.env.REACT_APP_API_BASE_URL;

// const getAuthHeader = () => {
//   const token = localStorage.getItem("token") || sessionStorage.getItem("token");
//   return token ? { Authorization: `Bearer ${token}` } : {};
// };

// const PKG_META = {
//   "pkg-silver":   { label: "Silver",   icon: "🥈", gradient: "linear-gradient(135deg,#006D77,#004E56)" },
//   "pkg-gold":     { label: "Gold",     icon: "🥇", gradient: "linear-gradient(135deg,#007A85,#005960)" },
//   "pkg-platinum": { label: "Platinum", icon: "💎", gradient: "linear-gradient(135deg,#005C65,#003D45)" },
//   "pkg-elite":    { label: "Elite",    icon: "👑", gradient: "linear-gradient(135deg,#008A96,#006370)" },
//   "pkg-diabetes": { label: "Diabetes", icon: "🩸", gradient: "linear-gradient(135deg,#004E56,#003040)" },
//   "pkg-women":    { label: "Women's",  icon: "🌸", gradient: "linear-gradient(135deg,#009AA6,#007080)" },
// };

// // Booking status → chip colours (same pattern as MyOrdersScreen STATUS_COLORS)
// const STATUS_COLORS = {
//   Pending:   { bg: "#FEF3C7", text: "#D97706", label: "Pending"   },
//   Confirmed: { bg: "#DBEAFE", text: "#2563EB", label: "Confirmed" },
//   Collected: { bg: "#E0E7FF", text: "#6366F1", label: "Collected" },
//   Completed: { bg: "#D1FAE5", text: "#059669", label: "Completed" },
//   Cancelled: { bg: "#FEE2E2", text: "#DC2626", label: "Cancelled" },
// };

// const PAYMENT_COLORS = {
//   Unpaid:   { bg: "#FEF3C7", text: "#D97706" },
//   Paid:     { bg: "#D1FAE5", text: "#059669" },
//   Refunded: { bg: "#F1F5F9", text: "#64748B" },
// };

// const StatusChip = ({ value }) => {
//   const c = STATUS_COLORS[value] || { bg: "#F1F5F9", text: "#64748B", label: value };
//   return (
//     <Chip
//       label={c.label}
//       size="small"
//       sx={{
//         bgcolor: c.bg, color: c.text,
//         fontWeight: 700, fontSize: 12,
//         borderRadius: "16px", px: 0.5,
//         pointerEvents: "none",
//       }}
//     />
//   );
// };

// const PayChip = ({ value }) => {
//   const c = PAYMENT_COLORS[value] || { bg: "#F1F5F9", text: "#64748B" };
//   return (
//     <Chip
//       label={value}
//       size="small"
//       sx={{
//         bgcolor: c.bg, color: c.text,
//         fontWeight: 700, fontSize: 12,
//         borderRadius: "16px", px: 0.5,
//         pointerEvents: "none",
//       }}
//     />
//   );
// };

// // ─── InfoItem (modal detail row) ────────────────────────────────────────────────
// const InfoItem = ({ label, value }) => (
//   <Box sx={{
//     background: "#F8FAFC", borderRadius: 2, p: "9px 12px",
//     border: "1px solid #E5E7EB", display: "flex", flexDirection: "column", gap: 0.3,
//   }}>
//     <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#6B7280", textTransform: "uppercase", letterSpacing: 0.4 }}>
//       {label}
//     </Typography>
//     <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#111827", wordBreak: "break-word" }}>
//       {value || "—"}
//     </Typography>
//   </Box>
// );

// // ─── Cancel Dialog ──────────────────────────────────────────────────────────────
// const CancelDialog = ({ booking, onConfirm, onClose, loading }) => (
//   <Dialog open onClose={onClose} maxWidth="xs" fullWidth
//     PaperProps={{ sx: { borderRadius: 3, p: 1 } }}>
//     <DialogContent sx={{ textAlign: "center", pt: 4, pb: 2 }}>
//       <Box sx={{
//         width: 60, height: 60, borderRadius: "50%",
//         bgcolor: "#FEF3C7", border: "2px solid #FDE68A",
//         display: "flex", alignItems: "center", justifyContent: "center",
//         mx: "auto", mb: 2,
//       }}>
//         <WarnIcon sx={{ fontSize: 30, color: "#D97706" }} />
//       </Box>
//       <Typography sx={{ fontFamily: "'Sora',sans-serif", fontSize: 18, fontWeight: 800, mb: 1, color: "#111827" }}>
//         Cancel Booking?
//       </Typography>
//       <Typography sx={{ fontSize: 14, color: "#6B7280", mb: 2, lineHeight: 1.7 }}>
//         Are you sure you want to cancel this booking?
//       </Typography>
//       <Box sx={{
//         bgcolor: "#E5E7EB", borderRadius: 2, py: 1, px: 2,
//         fontFamily: "monospace", fontSize: 14, fontWeight: 800, color: "#006D77",
//       }}>
//         {booking.booking_ref}
//       </Box>
//     </DialogContent>
//     <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
//       <Button fullWidth variant="outlined" onClick={onClose}
//         sx={{
//           borderColor: "#E5E7EB", color: "#6B7280", py: 1.25, borderRadius: 2,
//           "&:hover": { borderColor: "#9CA3AF", bgcolor: "#F9FAFB" },
//         }}>
//         Keep Booking
//       </Button>
//       <Button fullWidth variant="contained" onClick={() => onConfirm(booking.id)}
//         disabled={loading}
//         startIcon={loading ? <CircularProgress size={14} color="inherit" /> : <CancelIcon />}
//         sx={{
//           bgcolor: "#DC2626", py: 1.25, borderRadius: 2, fontWeight: 800,
//           "&:hover": { bgcolor: "#B91C1C" },
//         }}>
//         {loading ? "Cancelling..." : "Yes, Cancel"}
//       </Button>
//     </DialogActions>
//   </Dialog>
// );

// // ─── Booking Detail Modal ────────────────────────────────────────────────────────
// const BookingDetailModal = ({ booking, onClose, onCancelRequest }) => {
//   const muiTheme   = useTheme();
//   const fullScreen = useMediaQuery(muiTheme.breakpoints.down("sm"));
//   if (!booking) return null;

//   const meta      = PKG_META[booking.package_id] || {};
//   const savings   = booking.savings || (booking.mrp - booking.offer_price);
//   const discPct   = Math.round((savings / booking.mrp) * 100);
//   const canCancel = ["Pending", "Confirmed"].includes(booking.status);

//   return (
//     <Modal open onClose={onClose} closeAfterTransition BackdropComponent={Backdrop}
//       BackdropProps={{ timeout: 300, sx: { backdropFilter: "blur(5px)", backgroundColor: "rgba(0,0,0,0.5)" } }}>
//       <Fade in>
//         <Box sx={{
//           position: "absolute", top: "50%", left: "50%",
//           transform: "translate(-50%,-50%)",
//           width: fullScreen ? "95vw" : 520,
//           maxHeight: "90vh", overflowY: "auto",
//           bgcolor: "#fff", borderRadius: 3,
//           boxShadow: "0 24px 64px rgba(0,0,0,0.2)",
//         }}>
//           {/* Gradient header */}
//           <Box sx={{
//             background: meta.gradient || "linear-gradient(135deg,#006D77,#003D45)",
//             p: "24px 22px 18px", position: "relative", overflow: "hidden",
//           }}>
//             <Box sx={{ position: "absolute", top: -40, right: -40, width: 150, height: 150, borderRadius: "50%", background: "rgba(255,255,255,0.08)" }} />
//             <Box sx={{ position: "absolute", bottom: -30, left: -20, width: 110, height: 110, borderRadius: "50%", background: "rgba(255,255,255,0.06)" }} />
//             <IconButton onClick={onClose} size="small" sx={{
//               position: "absolute", top: 12, right: 12, zIndex: 2,
//               bgcolor: "rgba(255,255,255,0.2)", color: "#fff",
//               "&:hover": { bgcolor: "rgba(255,255,255,0.3)" },
//             }}>
//               <CloseIcon fontSize="small" />
//             </IconButton>
//             <Box sx={{ position: "relative", zIndex: 1 }}>
//               <Typography sx={{ fontSize: 32, lineHeight: 1, mb: 0.75 }}>{meta.icon || "📦"}</Typography>
//               <Typography sx={{
//                 fontFamily: "'Sora',sans-serif", fontWeight: 800,
//                 color: "#fff", fontSize: { xs: 15, sm: 17 }, mb: 0.5,
//               }}>
//                 {booking.package_name}
//               </Typography>
//               <Box sx={{
//                 display: "inline-block", bgcolor: "rgba(255,255,255,0.2)",
//                 color: "#fff", fontSize: 12, fontWeight: 800,
//                 px: 1.5, py: 0.3, borderRadius: 1.5, fontFamily: "monospace", mb: 1.5,
//               }}>
//                 {booking.booking_ref}
//               </Box>
//               <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
//                 <Box>
//                   <Typography sx={{ fontSize: 10, color: "rgba(255,255,255,0.6)", fontWeight: 600, mb: 0.25, textTransform: "uppercase" }}>
//                     Offer Price
//                   </Typography>
//                   <Typography sx={{ fontFamily: "'Sora',sans-serif", fontSize: 26, fontWeight: 900, color: "#80ED99", lineHeight: 1 }}>
//                     ₹{booking.offer_price?.toLocaleString()}
//                   </Typography>
//                 </Box>
//                 <Box sx={{ textAlign: "right" }}>
//                   <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.5)", textDecoration: "line-through" }}>
//                     ₹{booking.mrp?.toLocaleString()}
//                   </Typography>
//                   <Box sx={{
//                     mt: 0.5, bgcolor: "rgba(16,185,129,0.2)", border: "1px solid rgba(16,185,129,0.4)",
//                     color: "#80ED99", fontSize: 11, fontWeight: 800,
//                     px: 1.25, py: 0.3, borderRadius: 20, display: "inline-block",
//                   }}>
//                     Save ₹{savings?.toLocaleString()} ({discPct}% OFF)
//                   </Box>
//                 </Box>
//               </Box>
//             </Box>
//           </Box>

//           {/* Body */}
//           <Box sx={{ p: { xs: "14px 14px 20px", sm: "18px 20px 24px" } }}>
//             <Box sx={{ display: "flex", gap: 1, mb: 2, flexWrap: "wrap" }}>
//               <StatusChip value={booking.status} />
//               <PayChip value={booking.payment_status} />
//             </Box>

//             <Typography sx={{ fontSize: 11, fontWeight: 800, color: "#006D77", textTransform: "uppercase", letterSpacing: 0.5, mb: 1 }}>
//               Appointment
//             </Typography>
//             <Grid container spacing={1} mb={2}>
//               <Grid item xs={6}><InfoItem label="Date"      value={booking.preferred_date} /></Grid>
//               <Grid item xs={6}><InfoItem label="Time Slot" value={booking.preferred_time} /></Grid>
//             </Grid>

//             <Typography sx={{ fontSize: 11, fontWeight: 800, color: "#006D77", textTransform: "uppercase", letterSpacing: 0.5, mb: 1 }}>
//               Patient Details
//             </Typography>
//             <Grid container spacing={1} mb={2}>
//               {[
//                 ["Name",   booking.patient_name],
//                 ["Phone",  booking.phone],
//                 ["Email",  booking.email],
//                 ["Age",    booking.age],
//                 ["Gender", booking.gender],
//               ].map(([l, v]) => (
//                 <Grid item xs={6} key={l}><InfoItem label={l} value={v} /></Grid>
//               ))}
//             </Grid>

//             {booking.address && (
//               <Box mb={2}>
//                 <Typography sx={{ fontSize: 11, fontWeight: 800, color: "#006D77", textTransform: "uppercase", letterSpacing: 0.5, mb: 1 }}>
//                   Address
//                 </Typography>
//                 <InfoItem label="Address" value={booking.address} />
//               </Box>
//             )}

//             {booking.notes && (
//               <Box sx={{ bgcolor: "#F8FAFC", border: "1px solid #E5E7EB", borderRadius: 2, p: "10px 12px", mb: 2 }}>
//                 <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#6B7280", textTransform: "uppercase", letterSpacing: 0.4, mb: 0.5 }}>
//                   Notes
//                 </Typography>
//                 <Typography sx={{ fontSize: 13, color: "#374151", lineHeight: 1.7 }}>{booking.notes}</Typography>
//               </Box>
//             )}

//             {booking.created_at && (
//               <Typography sx={{ fontSize: 11, color: "#9CA3AF", textAlign: "center", mb: canCancel ? 1.5 : 0 }}>
//                 Booked on {booking.created_at}
//               </Typography>
//             )}

//             {canCancel && (
//               <Button fullWidth variant="outlined"
//                 startIcon={<CancelIcon />}
//                 onClick={() => onCancelRequest(booking)}
//                 sx={{
//                   mt: 0.5, py: 1.25, borderRadius: 2, fontWeight: 800, fontSize: 14,
//                   borderColor: "#FECACA", color: "#DC2626",
//                   "&:hover": { bgcolor: "#FEE2E2", borderColor: "#EF4444" },
//                 }}>
//                 Cancel This Booking
//               </Button>
//             )}
//           </Box>
//         </Box>
//       </Fade>
//     </Modal>
//   );
// };

// // ─── Booking Card ────────────────────────────────────────────────────────────────
// const BookingCard = ({ booking, onView, onCancelRequest }) => {
//   const meta      = PKG_META[booking.package_id] || {};
//   const savings   = booking.savings || (booking.mrp - booking.offer_price);
//   const canCancel = ["Pending", "Confirmed"].includes(booking.status);

//   return (
//     <Card
//       elevation={2}
//       sx={{
//         borderRadius: 3, mb: 2, overflow: "hidden",
//         border: "1px solid #E5E7EB",
//         "&:hover": { boxShadow: "0 3px 12px rgba(0,0,0,0.1)" },
//       }}
//     >
//       <CardContent sx={{ p: 2.5 }}>

//         {/* Header row: package name + status chips */}
//         <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 1.25 }}>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, flex: 1, mr: 1 }}>
//             {/* Package icon tile */}
//             <Box sx={{
//               width: 40, height: 40, borderRadius: 2, flexShrink: 0,
//               background: meta.gradient || "#006D77",
//               display: "flex", alignItems: "center", justifyContent: "center",
//               fontSize: 20,
//             }}>
//               {meta.icon || "📦"}
//             </Box>
//             <Box>
//               <Typography sx={{ fontSize: 16, fontWeight: 700, color: "#111827", lineHeight: 1.3 }}>
//                 {booking.package_name?.replace("Ayuja ", "")}
//               </Typography>
//               <code style={{
//                 fontSize: 11, color: "#006D77", background: "#E5E7EB",
//                 padding: "1px 7px", borderRadius: 5, fontWeight: 700,
//               }}>
//                 {booking.booking_ref}
//               </code>
//             </Box>
//           </Box>
//           <Box sx={{ display: "flex", gap: 0.75, flexShrink: 0, flexWrap: "wrap", justifyContent: "flex-end" }}>
//             <StatusChip value={booking.status} />
//             <PayChip value={booking.payment_status} />
//           </Box>
//         </Box>

//         {/* Appointment info */}
//         <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 1.25 }}>
//           {[
//             { icon: <CalendarIcon sx={{ fontSize: 13, color: "#006D77" }} />, text: booking.preferred_date },
//             { icon: <TimeIcon     sx={{ fontSize: 13, color: "#006D77" }} />, text: booking.preferred_time },
//             { icon: <PersonIcon   sx={{ fontSize: 13, color: "#006D77" }} />, text: booking.patient_name  },
//           ].filter(x => x.text).map((item, i) => (
//             <Box key={i} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//               {item.icon}
//               <Typography sx={{ fontSize: 13, color: "#374151", fontWeight: 500 }}>{item.text}</Typography>
//             </Box>
//           ))}
//         </Box>

//         {/* Price + actions — same layout as MyOrdersScreen's total row */}
//         <Box sx={{
//           display: "flex", justifyContent: "space-between", alignItems: "center",
//           borderTop: "1px solid #E5E7EB", pt: 1.5, mt: 0.5, flexWrap: "wrap", gap: 1,
//         }}>
//           <Box>
//             <Typography sx={{ fontSize: 12, color: "#6B7280" }}>Offer Price</Typography>
//             <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.25 }}>
//               <Box sx={{
//                 bgcolor: "#22577A", color: "#fff",
//                 fontSize: 15, fontWeight: 700,
//                 px: 2, py: 0.5, borderRadius: 2, display: "inline-block",
//               }}>
//                 ₹{booking.offer_price?.toLocaleString()}
//               </Box>
//               <Typography sx={{ fontSize: 12, color: "#9CA3AF", textDecoration: "line-through" }}>
//                 ₹{booking.mrp?.toLocaleString()}
//               </Typography>
//               {savings > 0 && (
//                 <Box sx={{
//                   bgcolor: "#E5FDCF", color: "#059669",
//                   fontSize: 11, fontWeight: 700,
//                   px: 1, py: 0.25, borderRadius: 4, border: "1px solid #D1FAE5",
//                 }}>
//                   Save ₹{savings?.toLocaleString()}
//                 </Box>
//               )}
//             </Box>
//           </Box>

//           <Box sx={{ display: "flex", gap: 1 }}>
//             {canCancel && (
//               <Button
//                 variant="outlined"
//                 onClick={(e) => { e.stopPropagation(); onCancelRequest(booking); }}
//                 sx={{
//                   borderColor: "#FECACA", color: "#DC2626",
//                   borderRadius: 3, fontWeight: 700, fontSize: 13,
//                   px: 2,
//                   "&:hover": { bgcolor: "#FEE2E2", borderColor: "#EF4444" },
//                 }}>
//                 Cancel
//               </Button>
//             )}
//             <Button
//               variant="outlined"
//               onClick={() => onView(booking)}
//               sx={{
//                 borderColor: "#006D77", bgcolor: "#22577A",
//                 color: "#fff", borderRadius: 3, fontWeight: 700, fontSize: 13,
//                 px: 2.5,
//                 "&:hover": { bgcolor: "#006D77" },
//               }}>
//               View Details
//             </Button>
//           </Box>
//         </Box>
//       </CardContent>
//     </Card>
//   );
// };

// // ─── Main Page ───────────────────────────────────────────────────────────────────
// const MyPackageBookings = () => {
//   const navigate = useNavigate();
//   const [bookings,     setBookings]     = useState([]);
//   const [stats,        setStats]        = useState({});
//   const [loading,      setLoading]      = useState(true);
//   const [refreshing,   setRefreshing]   = useState(false);
//   const [error,        setError]        = useState("");
//   const [filterStatus, setFilterStatus] = useState("all");
//   const [selectedBook, setSelectedBook] = useState(null);
//   const [cancelTarget, setCancelTarget] = useState(null);
//   const [cancelling,   setCancelling]   = useState(false);

//   const filters = [
//     { id: "all",       label: "All"       },
//     { id: "Pending",   label: "Pending"   },
//     { id: "Confirmed", label: "Confirmed" },
//     { id: "Collected", label: "Collected" },
//     { id: "Completed", label: "Completed" },
//     { id: "Cancelled", label: "Cancelled" },
//   ];

//   const fetchBookings = useCallback(async () => {
//     setLoading(true);
//     setError("");
//     try {
//       const res = await axios.get(`${API}/package-orders/my-bookings`, { headers: getAuthHeader() });
//       if (res.data.success) {
//         setBookings(res.data.bookings || []);
//         setStats(res.data.stats || {});
//       } else {
//         setError(res.data.error || "Failed to load bookings");
//       }
//     } catch (e) {
//       if (e.response?.status === 401) navigate("/login");
//       else setError("Unable to load bookings. Please try again.");
//     }
//     setLoading(false);
//     setRefreshing(false);
//   }, [navigate]);

//   useEffect(() => { fetchBookings(); }, [fetchBookings]);

//   const onRefresh = () => { setRefreshing(true); fetchBookings(); };

//   const handleCancel = async (bookingId) => {
//     setCancelling(true);
//     try {
//       const res = await axios.patch(
//         `${API}/package-orders/my-bookings/${bookingId}/cancel`,
//         {},
//         { headers: getAuthHeader() }
//       );
//       if (res.data.success) {
//         setCancelTarget(null);
//         setSelectedBook(null);
//         await fetchBookings();
//       } else {
//         alert(res.data.error || "Cancellation failed");
//       }
//     } catch (e) {
//       alert(e.response?.data?.error || "Cancellation failed");
//     }
//     setCancelling(false);
//   };

//   const filtered = filterStatus === "all"
//     ? bookings
//     : bookings.filter((b) => b.status === filterStatus);

//   // ── Loading screen (full page, same as MyOrdersScreen) ──────────────────────
//   if (loading && !refreshing) {
//     return (
//       <ThemeProvider theme={theme}>
//         <Box sx={{
//           display: "flex", flexDirection: "column",
//           alignItems: "center", justifyContent: "center",
//           minHeight: "100vh", bgcolor: "#F9FAFB",
//         }}>
//           <CircularProgress size={60} sx={{ color: "#006D77" }} />
//           <Typography sx={{ mt: 2, fontSize: 16, color: "#6B7280" }}>
//             Loading your bookings...
//           </Typography>
//         </Box>
//       </ThemeProvider>
//     );
//   }

//   return (
//     <ThemeProvider theme={theme}>
//       <Box sx={{ minHeight: "100vh", bgcolor: "#F9FAFB" }}>

//         {/* ── White Paper header — same as MyOrdersScreen ── */}
//         <Paper elevation={2} sx={{ bgcolor: "#fff", mb: 0 }}>
//           <Container maxWidth="lg">
//             <Box sx={{
//               py: { xs: 1.5, sm: 2, md: 3 },
//               display: "flex", alignItems: "center",
//               justifyContent: "space-between", gap: 1,
//               position: "relative",
//             }}>
//               <IconButton
//                 onClick={() => window.history.back()}
//                 sx={{ flexShrink: 0, bgcolor: "white", boxShadow: 1, "&:hover": { bgcolor: "#f5f5f5" } }}>
//                 <ArrowBackIcon />
//               </IconButton>
//               <Typography
//                 variant="h4"
//                 sx={{
//                   color: "#006D77", fontWeight: 600,
//                   fontSize: { xs: "1rem", sm: "1.4rem", md: "2rem" },
//                   textAlign: "center", flex: 1,
//                   fontFamily: "'Sora', sans-serif",
//                 }}>
//                 My Health Bookings
//               </Typography>
//               <IconButton
//                 onClick={onRefresh} disabled={refreshing}
//                 sx={{ position: "absolute", right: 0 }}>
//                 <RefreshIcon />
//               </IconButton>
//             </Box>
//           </Container>
//         </Paper>

//         {/* ── Filter chips row — same pattern as MyOrdersScreen ── */}
//         <Paper elevation={0} sx={{ bgcolor: "transparent", borderBottom: "1px solid #E5E7EB", py: 1.5 }}>
//           <Container maxWidth="lg">
//             <Box sx={{ display: "flex", gap: 1, overflowX: "auto", "&::-webkit-scrollbar": { display: "none" } }}>
//               {filters.map((filter) => (
//                 <Chip
//                   key={filter.id}
//                   label={
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                       <span>{filter.label}</span>
//                       {filter.id !== "all" && (
//                         <Box sx={{
//                           bgcolor: "#006D77", color: "#fff",
//                           fontSize: 11, fontWeight: 700,
//                           px: 0.55, py: 0.55, borderRadius: 1.25,
//                           minWidth: 20, textAlign: "center",
//                         }}>
//                           {bookings.filter((b) => b.status === filter.id).length}
//                         </Box>
//                       )}
//                     </Box>
//                   }
//                   onClick={() => setFilterStatus(filter.id)}
//                   sx={{
//                     bgcolor: filterStatus === filter.id ? "#006D77" : "white",
//                     color: filterStatus === filter.id ? "#fff" : "black",
//                     fontWeight: 600, fontSize: 14,
//                     border: filterStatus === filter.id ? "1px solid white" : "1px solid #006D77",
//                     cursor: "pointer",
//                     "&:hover": {
//                       bgcolor: filterStatus === filter.id ? "#005960" : "#E5E7EB",
//                     },
//                   }}
//                 />
//               ))}
//             </Box>
//           </Container>
//         </Paper>

//         {/* ── Stat cards — same solid teal style as MyOrdersScreen ── */}
//         {bookings.length > 0 && (
//           <Container maxWidth="lg" sx={{ py: 2 }}>
//             <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
//               {[
//                 { label: "Total Bookings", val: bookings.length },
//                 { label: "Completed",      val: bookings.filter(b => b.status === "Completed").length },
//                 { label: "Pending",        val: bookings.filter(b => b.status === "Pending").length   },
//                 { label: "Total Savings",  val: `₹${(stats.total_savings || 0).toLocaleString()}`     },
//               ].map((s) => (
//                 <Paper
//                   key={s.label}
//                   elevation={1}
//                   sx={{
//                     flex: 1, minWidth: 10,
//                     bgcolor: "#006D77", p: 2, borderRadius: 3, textAlign: "center",
//                   }}>
//                   <Typography sx={{ fontSize: 24, fontWeight: 700, color: "#fff", mb: 0.5, fontFamily: "'Sora',sans-serif" }}>
//                     {s.val}
//                   </Typography>
//                   <Typography sx={{ fontSize: 14, color: "#fff" }}>{s.label}</Typography>
//                 </Paper>
//               ))}
//             </Box>
//           </Container>
//         )}

//         {/* ── Order list / empty / error ── */}
//         <Container maxWidth="lg" sx={{ py: 2, pb: 6 }}>

//           {/* Error */}
//           {error && (
//             <Box sx={{ textAlign: "center", py: 6 }}>
//               <Alert severity="error" sx={{ borderRadius: 2, mb: 2, maxWidth: 420, mx: "auto" }}>{error}</Alert>
//               <Button variant="contained" onClick={fetchBookings}
//                 sx={{ bgcolor: "#006D77", borderRadius: 2, fontWeight: 700, "&:hover": { bgcolor: "#005960" } }}>
//                 Try Again
//               </Button>
//             </Box>
//           )}

//           {/* Empty */}
//           {!error && filtered.length === 0 && (
//             <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: 10 }}>
//               <Typography sx={{ fontSize: 72, mb: 2 }}>🗓️</Typography>
//               <Typography sx={{ fontSize: 20, fontWeight: 700, color: "#111827", mb: 1, fontFamily: "'Sora',sans-serif" }}>
//                 No Bookings Found
//               </Typography>
//               <Typography sx={{ fontSize: 14, color: "#6B7280", textAlign: "center", mb: 3, px: 4 }}>
//                 {filterStatus === "all"
//                   ? "You haven't booked any health packages yet"
//                   : `No ${filterStatus} bookings found`}
//               </Typography>
//               {filterStatus === "all" && (
//                 <Button
//                   variant="contained"
//                   onClick={() => navigate("/")}
//                   sx={{
//                     bgcolor: "#006D77", color: "#fff",
//                     fontWeight: 700, fontSize: 14, px: 3, py: 1.5,
//                     "&:hover": { bgcolor: "#005960" },
//                   }}>
//                   Browse Health Packages
//                 </Button>
//               )}
//             </Box>
//           )}

//           {/* Cards */}
//           {!error && filtered.length > 0 &&
//             filtered.map((b) => (
//               <BookingCard
//                 key={b.id}
//                 booking={b}
//                 onView={setSelectedBook}
//                 onCancelRequest={setCancelTarget}
//               />
//             ))
//           }
//         </Container>

//         {/* ── Modals ── */}
//         {selectedBook && (
//           <BookingDetailModal
//             booking={selectedBook}
//             onClose={() => setSelectedBook(null)}
//             onCancelRequest={(b) => setCancelTarget(b)}
//           />
//         )}
//         {cancelTarget && (
//           <CancelDialog
//             booking={cancelTarget}
//             onClose={() => setCancelTarget(null)}
//             onConfirm={handleCancel}
//             loading={cancelling}
//           />
//         )}
//       </Box>
//     </ThemeProvider>
//   );
// };

// export default MyPackageBookings;



import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import {
  Box, Container, Grid, Card, CardContent, Typography, Chip, Stack, Divider,
  Button, IconButton, Paper, Modal, Fade, Backdrop, CircularProgress,
  Alert, Dialog, DialogContent, DialogActions,
  useMediaQuery, useTheme,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  ArrowBack as ArrowBackIcon,
  Refresh as RefreshIcon,
  Close as CloseIcon,
  CalendarMonth as CalendarIcon,
  AccessTime as TimeIcon,
  Person as PersonIcon,
  CancelOutlined as CancelIcon,
  WarningAmberRounded as WarnIcon,
  InsertDriveFile as FileIcon,
  PictureAsPdf as PdfIcon,
  Image as ImageIcon,
  Description as DescriptionIcon,
  Download as DownloadIcon,
  Visibility as EyeIcon,
} from "@mui/icons-material";
import { apiRequest } from "../../fetchSetup"; // adjust path if needed

// ─── Theme ──────────────────────────────────────────────────────────────────────
const theme = createTheme({
  palette: {
    primary:    { main: "#006D77", light: "#4A9FA8", dark: "#003D45" },
    success:    { main: "#16A34A" },
    warning:    { main: "#D97706" },
    error:      { main: "#DC2626" },
    info:       { main: "#007A85" },
    background: { default: "#F9FAFB", paper: "#FFFFFF" },
  },
  typography: {
    fontFamily: "'DM Sans', sans-serif",
    h5: { fontFamily: "'Sora', sans-serif", fontWeight: 900 },
    h6: { fontFamily: "'Sora', sans-serif", fontWeight: 800 },
    button: { fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textTransform: "none" },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: { styleOverrides: { root: { textTransform: "none", fontWeight: 700 } } },
  },
});

// ─── API ─────────────────────────────────────────────────────────────────────────
const API = process.env.REACT_APP_API_BASE_URL;
// Download endpoint — user variant (read-only, no upload/delete)
// GET /package-orders/my-bookings/<booking_id>/documents/<filename>
// This should proxy to the same presigned-URL logic, or you can reuse the admin endpoint
// if your backend exposes a user-facing download route. Adjust the base if needed.
const USER_DOWNLOAD_PKG_DOC = process.env.REACT_APP_DOWNLOAD_PKG_BOOKING_DOC
  || `${API}/package-orders/my-bookings`;

const getAuthHeader = () => {
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// ─── Package meta ────────────────────────────────────────────────────────────────
const PKG_META = {
  "pkg-silver":   { label: "Silver",   icon: "🥈", gradient: "linear-gradient(135deg,#006D77,#004E56)" },
  "pkg-gold":     { label: "Gold",     icon: "🥇", gradient: "linear-gradient(135deg,#007A85,#005960)" },
  "pkg-platinum": { label: "Platinum", icon: "💎", gradient: "linear-gradient(135deg,#005C65,#003D45)" },
  "pkg-elite":    { label: "Elite",    icon: "👑", gradient: "linear-gradient(135deg,#008A96,#006370)" },
  "pkg-diabetes": { label: "Diabetes", icon: "🩸", gradient: "linear-gradient(135deg,#004E56,#003040)" },
  "pkg-women":    { label: "Women's",  icon: "🌸", gradient: "linear-gradient(135deg,#009AA6,#007080)" },
};

const STATUS_COLORS = {
  Pending:   { bg: "#FEF3C7", text: "#D97706", label: "Pending"   },
  Confirmed: { bg: "#DBEAFE", text: "#2563EB", label: "Confirmed" },
  Collected: { bg: "#E0E7FF", text: "#6366F1", label: "Collected" },
  Completed: { bg: "#D1FAE5", text: "#059669", label: "Completed" },
  Cancelled: { bg: "#FEE2E2", text: "#DC2626", label: "Cancelled" },
};
const PAYMENT_COLORS = {
  Unpaid:   { bg: "#FEF3C7", text: "#D97706" },
  Paid:     { bg: "#D1FAE5", text: "#059669" },
  Refunded: { bg: "#F1F5F9", text: "#64748B" },
};

// ─── Helpers ─────────────────────────────────────────────────────────────────────
const StatusChip = ({ value }) => {
  const c = STATUS_COLORS[value] || { bg: "#F1F5F9", text: "#64748B", label: value };
  return (
    <Chip label={c.label} size="small"
      sx={{ bgcolor: c.bg, color: c.text, fontWeight: 700, fontSize: 12, borderRadius: "16px", px: 0.5, pointerEvents: "none" }} />
  );
};
const PayChip = ({ value }) => {
  const c = PAYMENT_COLORS[value] || { bg: "#F1F5F9", text: "#64748B" };
  return (
    <Chip label={value} size="small"
      sx={{ bgcolor: c.bg, color: c.text, fontWeight: 700, fontSize: 12, borderRadius: "16px", px: 0.5, pointerEvents: "none" }} />
  );
};

const InfoItem = ({ label, value }) => (
  <Box sx={{ background: "#F8FAFC", borderRadius: 2, p: "9px 12px", border: "1px solid #E5E7EB" }}>
    <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#6B7280", textTransform: "uppercase", letterSpacing: 0.4, mb: 0.3 }}>
      {label}
    </Typography>
    <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#111827", wordBreak: "break-word" }}>
      {value || "—"}
    </Typography>
  </Box>
);

// ─── File icon helper — same as admin ────────────────────────────────────────────
const getFileIcon = (fileName, size = 36) => {
  const ext = (fileName || "").split(".").pop().toLowerCase();
  const sx  = { fontSize: size };
  switch (ext) {
    case "pdf":  return <PdfIcon         sx={{ ...sx, color: "#EF4444" }} />;
    case "png":
    case "jpg":
    case "jpeg": return <ImageIcon       sx={{ ...sx, color: "#3B82F6" }} />;
    case "doc":
    case "docx": return <DescriptionIcon sx={{ ...sx, color: "#2563EB" }} />;
    default:     return <FileIcon        sx={{ ...sx, color: "#6B7280" }} />;
  }
};

const isImageFile = (f = "") => ["png", "jpg", "jpeg", "gif", "webp"].includes(f.split(".").pop().toLowerCase());
const isPdfFile   = (f = "") => f.split(".").pop().toLowerCase() === "pdf";

// ─── User Documents Section ───────────────────────────────────────────────────────
// Read-only: users can preview and download documents uploaded by admin.
// Documents are stored in booking.documents[] — each item has:
//   filename, original_filename, cloudfront_url, s3_key, storage_type, uploaded_at
const UserDocumentsSection = ({ booking }) => {
  const [downloading, setDownloading] = useState(null); // filename being downloaded
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewDoc,  setPreviewDoc]  = useState(null);
  const [previewBlob, setPreviewBlob] = useState(null); // { url, isImage, isPdf, filename }
  const [docError,    setDocError]    = useState("");

  const docs = booking.documents || [];

  useEffect(() => {
    return () => {
      if (previewBlob?.url) URL.revokeObjectURL(previewBlob.url);
    };
  }, [previewBlob]);

  // ── Download — mirrors admin handleDownloadDoc exactly ──────────────────────
  // Backend: GET /package-orders/my-bookings/<id>/documents/<filename>
  //   S3   → JSON { success, download_url }  (generate_presigned_download_url)
  //   local → raw file bytes via send_file()
  const handleDownload = async (doc) => {
    const filename = doc.filename;
    setDownloading(filename);
    setDocError("");
    try {
      // If CloudFront URL is already available (S3 uploads always have it),
      // try direct link first — avoids an extra round-trip.
      if (doc.cloudfront_url && doc.storage_type === "s3") {
        const a    = document.createElement("a");
        a.href     = doc.cloudfront_url;
        a.target   = "_blank";
        a.rel      = "noopener noreferrer";
        a.download = doc.original_filename || filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        return;
      }

      // Fallback: ask backend for a presigned URL or raw bytes
      const response = await apiRequest(
        `${USER_DOWNLOAD_PKG_DOC}/${booking.id}/documents/${filename}`,
        { method: "GET" }
      );
      if (!response.ok) throw new Error(`Server error: ${response.status}`);

      const contentType = response.headers.get("content-type") || "";

      // S3 path: JSON { download_url }
      if (contentType.includes("application/json")) {
        const data = await response.json();
        if (data.download_url) {
          const a    = document.createElement("a");
          a.href     = data.download_url;
          a.target   = "_blank";
          a.rel      = "noopener noreferrer";
          a.download = data.filename || filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          return;
        }
        throw new Error("No download URL in response");
      }

      // Local path: raw bytes
      const blob    = await response.blob();
      if (!blob || blob.size === 0) throw new Error("Empty file");
      const blobUrl = URL.createObjectURL(blob);
      const a       = document.createElement("a");
      a.href        = blobUrl;
      a.download    = doc.original_filename || filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(blobUrl);
    } catch (err) {
      setDocError("Download failed: " + err.message);
    } finally {
      setDownloading(null);
    }
  };

  // ── Preview ──────────────────────────────────────────────────────────────────
  // S3 uploads: open CloudFront URL directly in new tab (no extra request needed).
  // Local uploads: fetch blob from backend and show inline.
  const handlePreview = async (doc) => {
    setDocError("");
    const origName = doc.original_filename || doc.filename;

    // S3 — cloudfront_url is always set; open directly
    if (doc.cloudfront_url && doc.storage_type === "s3") {
      window.open(doc.cloudfront_url, "_blank", "noopener,noreferrer");
      return;
    }

    // Local — fetch blob from backend
    try {
      const response = await apiRequest(
        `${USER_DOWNLOAD_PKG_DOC}/${booking.id}/documents/${doc.filename}`,
        { method: "GET" }
      );
      if (!response.ok) throw new Error(`${response.status}`);

      const contentType = response.headers.get("content-type") || "";
      if (contentType.includes("application/json")) {
        const data = await response.json();
        if (data.download_url) { window.open(data.download_url, "_blank"); return; }
      }

      const blob = await response.blob();
      if (!blob || blob.size === 0) throw new Error("Empty file");
      if (previewBlob?.url) URL.revokeObjectURL(previewBlob.url);

      setPreviewDoc(doc);
      setPreviewBlob({ url: URL.createObjectURL(blob), isImage: isImageFile(origName), isPdf: isPdfFile(origName), filename: origName });
      setPreviewOpen(true);
    } catch (err) {
      setDocError("Preview failed: " + err.message);
    }
  };

  const closePreview = () => {
    setPreviewOpen(false);
    if (previewBlob?.url) URL.revokeObjectURL(previewBlob.url);
    setPreviewBlob(null);
    setPreviewDoc(null);
  };

  if (docs.length === 0) return null; // No docs? Show nothing to the user.

  return (
    <>
      <Box sx={{ mt: 2.5 }}>
        {/* Section header */}
        <Box sx={{
          display: "flex", alignItems: "center", gap: 1.25, mb: 1.5,
          pb: 1.25, borderBottom: "1px solid #E5E7EB",
        }}>
          <Box sx={{
            width: 32, height: 32, borderRadius: 2,
            background: "linear-gradient(135deg,#006D77,#004E56)",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}>
            <FileIcon sx={{ fontSize: 17, color: "#fff" }} />
          </Box>
          <Typography sx={{ fontFamily: "'Sora',sans-serif", fontWeight: 800, fontSize: 15, color: "#111827" }}>
            Your Documents
          </Typography>
          <Chip label={`${docs.length} File${docs.length > 1 ? "s" : ""}`} size="small"
            sx={{ bgcolor: "#ECFDF5", color: "#059669", fontWeight: 700, fontSize: 11, ml: "auto" }} />
        </Box>

        {docError && (
          <Alert severity="error" sx={{ mb: 1.5, borderRadius: 2 }} onClose={() => setDocError("")}>
            {docError}
          </Alert>
        )}

        {/* Document cards grid */}
        <Grid container spacing={1.5}>
          {docs.map((doc, idx) => {
            const origName   = doc.original_filename || doc.filename || `Document ${idx + 1}`;
            const uploadedAt = doc.uploaded_at;
            const isLoading  = downloading === doc.filename;

            return (
              <Grid item xs={12} sm={6} key={idx}>
                <Box sx={{
                  display: "flex", alignItems: "center", gap: 1.5,
                  p: "10px 14px", borderRadius: 2.5,
                  border: "1.5px solid #E5E7EB",
                  background: "#FAFAFA",
                  transition: "all 0.18s",
                  "&:hover": { borderColor: "#006D77", background: "#F0F9F9", boxShadow: "0 2px 10px rgba(0,109,119,0.1)" },
                }}>
                  {/* File icon */}
                  <Box sx={{ flexShrink: 0 }}>{getFileIcon(origName, 32)}</Box>

                  {/* Name + date */}
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#111827", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                      title={origName}>
                      {origName.length > 28 ? `${origName.substring(0, 28)}…` : origName}
                    </Typography>
                    {uploadedAt && (
                      <Typography sx={{ fontSize: 11, color: "#9CA3AF", mt: 0.25 }}>
                        {new Date(uploadedAt).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}
                      </Typography>
                    )}
                  </Box>

                  {/* Action buttons */}
                  <Stack direction="row" spacing={0.75} flexShrink={0}>
                    {/* Preview — only if has a cloudfront_url or is a local file we can inline */}
                    <IconButton size="small"
                      title="Preview"
                      onClick={() => handlePreview(doc)}
                      sx={{ bgcolor: "#DBEAFE", "&:hover": { bgcolor: "#BFDBFE" }, width: 32, height: 32 }}>
                      <EyeIcon sx={{ fontSize: 15, color: "#2563EB" }} />
                    </IconButton>

                    {/* Download */}
                    <IconButton size="small"
                      title="Download"
                      onClick={() => handleDownload(doc)}
                      disabled={isLoading}
                      sx={{ bgcolor: "#D1FAE5", "&:hover": { bgcolor: "#A7F3D0" }, width: 32, height: 32 }}>
                      {isLoading
                        ? <CircularProgress size={13} sx={{ color: "#059669" }} />
                        : <DownloadIcon sx={{ fontSize: 15, color: "#059669" }} />
                      }
                    </IconButton>
                  </Stack>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Box>

      {/* Preview dialog */}
      <Dialog open={previewOpen} onClose={closePreview} maxWidth="md" fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}>
        <Box sx={{
          display: "flex", alignItems: "center", justifyContent: "space-between",
          px: 2.5, py: 1.75, bgcolor: "#006D77",
        }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <FileIcon sx={{ color: "#fff", fontSize: 20 }} />
            <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: 15 }}>
              {previewDoc?.original_filename || previewDoc?.filename || "Document Preview"}
            </Typography>
          </Box>
          <IconButton onClick={closePreview} sx={{ color: "#fff" }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        <DialogContent sx={{ p: 0 }}>
          {previewBlob && (
            previewBlob.isImage ? (
              <Box sx={{ p: 2, textAlign: "center" }}>
                <img src={previewBlob.url} alt={previewBlob.filename}
                  style={{ maxWidth: "100%", maxHeight: 500, borderRadius: 8 }} />
              </Box>
            ) : previewBlob.isPdf ? (
              <iframe src={previewBlob.url} title="PDF Preview"
                style={{ width: "100%", height: 550, border: "none" }} />
            ) : (
              <Box sx={{ p: 5, textAlign: "center" }}>
                <FileIcon sx={{ fontSize: 64, color: "grey.300", mb: 1 }} />
                <Typography color="text.secondary">Preview not available. Please download the file.</Typography>
              </Box>
            )
          )}
        </DialogContent>
        <DialogContent sx={{ pt: 0, pb: 2, display: "flex", justifyContent: "center" }}>
          {previewDoc && (
            <Button variant="contained" startIcon={<DownloadIcon />}
              onClick={() => handleDownload(previewDoc)}
              sx={{ bgcolor: "#006D77", "&:hover": { bgcolor: "#005761" }, borderRadius: 2, px: 3 }}>
              Download
            </Button>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

// ─── Cancel Dialog ────────────────────────────────────────────────────────────────
const CancelDialog = ({ booking, onConfirm, onClose, loading }) => (
  <Dialog open onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 3, p: 1 } }}>
    <DialogContent sx={{ textAlign: "center", pt: 4, pb: 2 }}>
      <Box sx={{ width: 60, height: 60, borderRadius: "50%", bgcolor: "#FEF3C7", border: "2px solid #FDE68A", display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
        <WarnIcon sx={{ fontSize: 30, color: "#D97706" }} />
      </Box>
      <Typography sx={{ fontFamily: "'Sora',sans-serif", fontSize: 18, fontWeight: 800, mb: 1, color: "#111827" }}>
        Cancel Booking?
      </Typography>
      <Typography sx={{ fontSize: 14, color: "#6B7280", mb: 2, lineHeight: 1.7 }}>
        Are you sure you want to cancel this booking?
      </Typography>
      <Box sx={{ bgcolor: "#E5E7EB", borderRadius: 2, py: 1, px: 2, fontFamily: "monospace", fontSize: 14, fontWeight: 800, color: "#006D77" }}>
        {booking.booking_ref}
      </Box>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
      <Button fullWidth variant="outlined" onClick={onClose}
        sx={{ borderColor: "#E5E7EB", color: "#6B7280", py: 1.25, borderRadius: 2, "&:hover": { borderColor: "#9CA3AF", bgcolor: "#F9FAFB" } }}>
        Keep Booking
      </Button>
      <Button fullWidth variant="contained" onClick={() => onConfirm(booking.id)}
        disabled={loading}
        startIcon={loading ? <CircularProgress size={14} color="inherit" /> : <CancelIcon />}
        sx={{ bgcolor: "#DC2626", py: 1.25, borderRadius: 2, fontWeight: 800, "&:hover": { bgcolor: "#B91C1C" } }}>
        {loading ? "Cancelling..." : "Yes, Cancel"}
      </Button>
    </DialogActions>
  </Dialog>
);

// ─── Booking Detail Modal — with documents ────────────────────────────────────────
const BookingDetailModal = ({ booking, onClose, onCancelRequest }) => {
  const muiTheme   = useTheme();
  const fullScreen = useMediaQuery(muiTheme.breakpoints.down("sm"));
  if (!booking) return null;

  const meta      = PKG_META[booking.package_id] || {};
  const savings   = booking.savings || (booking.mrp - booking.offer_price);
  const discPct   = Math.round((savings / booking.mrp) * 100);
  const canCancel = ["Pending", "Confirmed"].includes(booking.status);
  const hasDocs   = (booking.documents || []).length > 0;

    const handleInvoiceDownload=async(order_id)=>{
        try {
              const token = sessionStorage.getItem("token");
  
              const response = await axios.get(
                `${process.env.REACT_APP_API_INVOICE}/package-invoice/download/${order_id}`,
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              );
              const download_url=response.data.download_url
              window.open(download_url, "_blank");
            } catch (error) {
              console.error("Invoice download failed:", error);
            }
  }

  return (
    <Modal open onClose={onClose} closeAfterTransition BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 300, sx: { backdropFilter: "blur(5px)", backgroundColor: "rgba(0,0,0,0.5)" } }}>
      <Fade in>
        <Box sx={{
          position: "absolute", top: "50%", left: "50%",
          transform: "translate(-50%,-50%)",
          width: fullScreen ? "95vw" : 540,
          maxHeight: "92vh", overflowY: "auto",
          bgcolor: "#fff", borderRadius: 3,
          boxShadow: "0 24px 64px rgba(0,0,0,0.2)",
        }}>
          {/* Gradient header */}
          <Box sx={{ background: meta.gradient || "linear-gradient(135deg,#006D77,#003D45)", p: "24px 22px 18px", position: "relative", overflow: "hidden" }}>
            <Box sx={{ position: "absolute", top: -40, right: -40, width: 150, height: 150, borderRadius: "50%", background: "rgba(255,255,255,0.08)" }} />
            <Box sx={{ position: "absolute", bottom: -30, left: -20, width: 110, height: 110, borderRadius: "50%", background: "rgba(255,255,255,0.06)" }} />
            <IconButton onClick={onClose} size="small" sx={{ position: "absolute", top: 12, right: 12, zIndex: 2, bgcolor: "rgba(255,255,255,0.2)", color: "#fff", "&:hover": { bgcolor: "rgba(255,255,255,0.3)" } }}>
              <CloseIcon fontSize="small" />
            </IconButton>
            <Box sx={{ position: "relative", zIndex: 1 }}>
              <Typography sx={{ fontSize: 32, lineHeight: 1, mb: 0.75 }}>{meta.icon || "📦"}</Typography>
              <Typography sx={{ fontFamily: "'Sora',sans-serif", fontWeight: 800, color: "#fff", fontSize: { xs: 15, sm: 17 }, mb: 0.5 }}>
                {booking.package_name}
              </Typography>
              <Box sx={{ display: "inline-block", bgcolor: "rgba(255,255,255,0.2)", color: "#fff", fontSize: 12, fontWeight: 800, px: 1.5, py: 0.3, borderRadius: 1.5, fontFamily: "monospace", mb: 1.5 }}>
                {booking.booking_ref}
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
                <Box>
                  <Typography sx={{ fontSize: 10, color: "rgba(255,255,255,0.6)", fontWeight: 600, mb: 0.25, textTransform: "uppercase" }}>Offer Price</Typography>
                  <Typography sx={{ fontFamily: "'Sora',sans-serif", fontSize: 26, fontWeight: 900, color: "#80ED99", lineHeight: 1 }}>
                    ₹{booking.offer_price?.toLocaleString()}
                  </Typography>
                </Box>
                <Box sx={{ textAlign: "right" }}>
                  <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.5)", textDecoration: "line-through" }}>
                    ₹{booking.mrp?.toLocaleString()}
                  </Typography>
                  <Box sx={{ mt: 0.5, bgcolor: "rgba(16,185,129,0.2)", border: "1px solid rgba(16,185,129,0.4)", color: "#80ED99", fontSize: 11, fontWeight: 800, px: 1.25, py: 0.3, borderRadius: 20, display: "inline-block" }}>
                    Save ₹{savings?.toLocaleString()} ({discPct}% OFF)
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>

          {/* Body */}
          <Box sx={{ p: { xs: "14px 14px 22px", sm: "18px 20px 26px" } }}>
            <Box sx={{ display: "flex", gap: 1, mb: 2, flexWrap: "wrap" }}>
              <StatusChip value={booking.status} />
              <PayChip value={booking.payment_status} />
            </Box>

            {/* Appointment */}
            <Typography sx={{ fontSize: 11, fontWeight: 800, color: "#006D77", textTransform: "uppercase", letterSpacing: 0.5, mb: 1 }}>Appointment</Typography>
            <Grid container spacing={1} mb={2}>
              <Grid item xs={6}><InfoItem label="Date"      value={booking.preferred_date} /></Grid>
              <Grid item xs={6}><InfoItem label="Time Slot" value={booking.preferred_time} /></Grid>
            </Grid>

            {/* Patient */}
            <Typography sx={{ fontSize: 11, fontWeight: 800, color: "#006D77", textTransform: "uppercase", letterSpacing: 0.5, mb: 1 }}>Patient Details</Typography>
            <Grid container spacing={1} mb={2}>
              {[["Name", booking.patient_name], ["Phone", booking.phone], ["Email", booking.email], ["Age", booking.age], ["Gender", booking.gender]].map(([l, v]) => (
                <Grid item xs={6} key={l}><InfoItem label={l} value={v} /></Grid>
              ))}
            </Grid>

            {booking.address && (
              <Box mb={2}>
                <Typography sx={{ fontSize: 11, fontWeight: 800, color: "#006D77", textTransform: "uppercase", letterSpacing: 0.5, mb: 1 }}>Address</Typography>
                <InfoItem label="Address" value={booking.address} />
              </Box>
            )}

            {booking.notes && (
              <Box sx={{ bgcolor: "#F8FAFC", border: "1px solid #E5E7EB", borderRadius: 2, p: "10px 12px", mb: 2 }}>
                <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#6B7280", textTransform: "uppercase", letterSpacing: 0.4, mb: 0.5 }}>Notes</Typography>
                <Typography sx={{ fontSize: 13, color: "#374151", lineHeight: 1.7 }}>{booking.notes}</Typography>
              </Box>
            )}
             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
                                                              <Button
                                                                variant="contained"
                                                                size="small"
                                                                startIcon={<DownloadIcon />}
                                                                onClick={() => {
                                                                  handleInvoiceDownload(booking.booking_ref)
                                                                }}
                                                                sx={{ 
                                                                  bgcolor: '#006D77', 
                                                                  '&:hover': { bgcolor: '#005560' },
                                                                  textTransform: 'none'
                                                                }}
                                                              >
                                                                Download Invoice
                                                              </Button>
                                                            </Box>

            {/* ── Documents section — read-only for users ────────────────────── */}
            {/* Only rendered when admin has uploaded documents for this booking.  */}
            {/* Each doc: { filename, original_filename, cloudfront_url, s3_key,  */}
            {/*             storage_type, uploaded_at, uploaded_by, file_size }   */}
            {hasDocs && <UserDocumentsSection booking={booking} />}

            {booking.created_at && (
              <Typography sx={{ fontSize: 11, color: "#9CA3AF", textAlign: "center", mt: 2, mb: canCancel ? 1.5 : 0 }}>
                Booked on {booking.created_at}
              </Typography>
            )}

            {canCancel && (
              <Button fullWidth variant="outlined" startIcon={<CancelIcon />}
                onClick={() => onCancelRequest(booking)}
                sx={{ mt: 0.5, py: 1.25, borderRadius: 2, fontWeight: 800, fontSize: 14, borderColor: "#FECACA", color: "#DC2626", "&:hover": { bgcolor: "#FEE2E2", borderColor: "#EF4444" } }}>
                Cancel This Booking
              </Button>
            )}
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

// ─── CardDocumentsPanel ──────────────────────────────────────────────────────────
// Collapsible inline document panel shown directly on the booking card.
// Users can expand, preview (opens CloudFront URL) and download without opening modal.
const CardDocumentsPanel = ({ booking, docCount }) => {
  const [open,        setOpen]        = useState(false);
  const [downloading, setDownloading] = useState(null);
  const [panelError,  setPanelError]  = useState("");
  const docs = booking.documents || [];

  const handleDownload = async (doc) => {
    const filename = doc.filename;
    setDownloading(filename);
    setPanelError("");
    try {
      // S3: use cloudfront_url directly — fastest, no extra request
      if (doc.cloudfront_url && doc.storage_type === "s3") {
        const a = document.createElement("a");
        a.href     = doc.cloudfront_url;
        a.target   = "_blank";
        a.rel      = "noopener noreferrer";
        a.download = doc.original_filename || filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        return;
      }
      // Local / fallback: ask backend
      const response = await apiRequest(
        `${USER_DOWNLOAD_PKG_DOC}/${booking.id}/documents/${filename}`,
        { method: "GET" }
      );
      if (!response.ok) throw new Error(`Server error: ${response.status}`);
      const contentType = response.headers.get("content-type") || "";
      if (contentType.includes("application/json")) {
        const data = await response.json();
        if (data.download_url) {
          const a = document.createElement("a");
          a.href = data.download_url; a.target = "_blank"; a.rel = "noopener noreferrer";
          a.download = data.filename || filename;
          document.body.appendChild(a); a.click(); document.body.removeChild(a);
          return;
        }
        throw new Error("No download URL in response");
      }
      const blob = await response.blob();
      if (!blob || blob.size === 0) throw new Error("Empty file");
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl; a.download = doc.original_filename || filename;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      URL.revokeObjectURL(blobUrl);
    } catch (err) {
      setPanelError("Download failed: " + err.message);
    } finally {
      setDownloading(null);
    }
  };

  const handleView = (doc) => {
    // S3: open CloudFront URL directly in new tab
    if (doc.cloudfront_url && doc.storage_type === "s3") {
      window.open(doc.cloudfront_url, "_blank", "noopener,noreferrer");
      return;
    }
    // Local fallback: try to fetch and open
    apiRequest(`${USER_DOWNLOAD_PKG_DOC}/${booking.id}/documents/${doc.filename}`, { method: "GET" })
      .then(async (r) => {
        if (!r.ok) throw new Error();
        const ct = r.headers.get("content-type") || "";
        if (ct.includes("application/json")) {
          const d = await r.json();
          if (d.download_url) { window.open(d.download_url, "_blank"); return; }
        }
        const blob = await r.blob();
        window.open(URL.createObjectURL(blob), "_blank");
      })
      .catch(() => setPanelError("Could not open file. Try downloading instead."));
  };

  return (
    <Box sx={{ mb: 1.5 }}>
      {/* Collapse toggle header */}
      <Box
        onClick={() => setOpen((v) => !v)}
        sx={{
          display: "flex", alignItems: "center", gap: 1,
          px: 1.5, py: 0.9, cursor: "pointer",
          bgcolor: open ? "#ECFDF5" : "#F0FDF4",
          border: `1.5px solid ${open ? "#6EE7B7" : "#A7F3D0"}`,
          borderRadius: open ? "10px 10px 0 0" : 2,
          transition: "all 0.18s",
          "&:hover": { bgcolor: "#ECFDF5", borderColor: "#6EE7B7" },
          userSelect: "none",
        }}
      >
        <Box sx={{
          width: 26, height: 26, borderRadius: 1.5, flexShrink: 0,
          bgcolor: "#059669", display: "flex", alignItems: "center", justifyContent: "center",
        }}>
          <FileIcon sx={{ fontSize: 14, color: "#fff" }} />
        </Box>
        <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#065F46", flex: 1 }}>
          {docCount} Report{docCount > 1 ? "s" : ""} Ready
        </Typography>
        <Typography sx={{ fontSize: 11, fontWeight: 600, color: "#059669" }}>
          {open ? "Hide ▲" : "View & Download ▼"}
        </Typography>
      </Box>

      {/* Expanded doc rows */}
      {open && (
        <Box sx={{
          border: "1.5px solid #6EE7B7", borderTop: "none",
          borderRadius: "0 0 10px 10px", bgcolor: "#F9FAFB",
          px: 1.5, pt: 1, pb: 1.25,
        }}>
          {panelError && (
            <Alert severity="error" sx={{ mb: 1, borderRadius: 1.5, py: 0.25, fontSize: 12 }}
              onClose={() => setPanelError("")}>
              {panelError}
            </Alert>
          )}
          {docs.map((doc, idx) => {
            const origName  = doc.original_filename || doc.filename || `Document ${idx + 1}`;
            const isLoading = downloading === doc.filename;
            return (
              <Box key={idx} sx={{
                display: "flex", alignItems: "center", gap: 1.25,
                py: 0.9,
                borderBottom: idx < docs.length - 1 ? "1px solid #E5E7EB" : "none",
              }}>
                {/* Icon */}
                <Box sx={{ flexShrink: 0 }}>{getFileIcon(origName, 26)}</Box>

                {/* Name */}
                <Typography sx={{
                  flex: 1, fontSize: 13, fontWeight: 600, color: "#111827",
                  overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                }} title={origName}>
                  {origName.length > 30 ? `${origName.substring(0, 30)}…` : origName}
                </Typography>

                {/* Uploaded date */}
                {doc.uploaded_at && (
                  <Typography sx={{ fontSize: 10, color: "#9CA3AF", flexShrink: 0, display: { xs: "none", sm: "block" } }}>
                    {new Date(doc.uploaded_at).toLocaleDateString("en-IN", { day: "2-digit", month: "short" })}
                  </Typography>
                )}

                {/* Action buttons */}
                <Stack direction="row" spacing={0.75} flexShrink={0}>
                  <Button size="small" variant="outlined"
                    startIcon={<EyeIcon sx={{ fontSize: 13 }} />}
                    onClick={(e) => { e.stopPropagation(); handleView(doc); }}
                    sx={{
                      borderColor: "#BFDBFE", color: "#2563EB", borderRadius: 1.5,
                      fontSize: 11, px: 1, py: 0.3, minWidth: 0,
                      "&:hover": { bgcolor: "#DBEAFE", borderColor: "#93C5FD" },
                    }}>
                    View
                  </Button>
                  <Button size="small" variant="contained"
                    startIcon={isLoading
                      ? <CircularProgress size={11} color="inherit" />
                      : <DownloadIcon sx={{ fontSize: 13 }} />
                    }
                    onClick={(e) => { e.stopPropagation(); handleDownload(doc); }}
                    disabled={isLoading}
                    sx={{
                      bgcolor: "#059669", borderRadius: 1.5,
                      fontSize: 11, px: 1, py: 0.3, minWidth: 0,
                      "&:hover": { bgcolor: "#047857" },
                    }}>
                    {isLoading ? "…" : "Download"}
                  </Button>
                </Stack>
              </Box>
            );
          })}
        </Box>
      )}
    </Box>
  );
};

// ─── Booking Card — with document badge ──────────────────────────────────────────
const BookingCard = ({ booking, onView, onCancelRequest }) => {
  const meta      = PKG_META[booking.package_id] || {};
  const savings   = booking.savings || (booking.mrp - booking.offer_price);
  const canCancel = ["Pending", "Confirmed"].includes(booking.status);
  // documents[] is set by admin upload; show a badge when present
  const docCount  = (booking.documents || []).length;

  return (
    <Card elevation={2} sx={{ borderRadius: 3, mb: 2, overflow: "hidden", border: "1px solid #E5E7EB", "&:hover": { boxShadow: "0 3px 12px rgba(0,0,0,0.1)" } }}>
      <CardContent sx={{ p: 2.5 }}>
        {/* Header */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 1.25 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, flex: 1, mr: 1 }}>
            <Box sx={{ width: 40, height: 40, borderRadius: 2, flexShrink: 0, background: meta.gradient || "#006D77", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20 }}>
              {meta.icon || "📦"}
            </Box>
            <Box>
              <Typography sx={{ fontSize: 16, fontWeight: 700, color: "#111827", lineHeight: 1.3 }}>
                {booking.package_name?.replace("Ayuja ", "")}
              </Typography>
              <code style={{ fontSize: 11, color: "#006D77", background: "#E5E7EB", padding: "1px 7px", borderRadius: 5, fontWeight: 700 }}>
                {booking.booking_ref}
              </code>
            </Box>
          </Box>
          <Box sx={{ display: "flex", gap: 0.75, flexShrink: 0, flexWrap: "wrap", justifyContent: "flex-end" }}>
            <StatusChip value={booking.status} />
            <PayChip value={booking.payment_status} />
          </Box>
        </Box>

        {/* Appointment row */}
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 1.25 }}>
          {[
            { icon: <CalendarIcon sx={{ fontSize: 13, color: "#006D77" }} />, text: booking.preferred_date },
            { icon: <TimeIcon     sx={{ fontSize: 13, color: "#006D77" }} />, text: booking.preferred_time },
            { icon: <PersonIcon   sx={{ fontSize: 13, color: "#006D77" }} />, text: booking.patient_name  },
          ].filter(x => x.text).map((item, i) => (
            <Box key={i} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              {item.icon}
              <Typography sx={{ fontSize: 13, color: "#374151", fontWeight: 500 }}>{item.text}</Typography>
            </Box>
          ))}
        </Box>

        {/* Inline documents panel — directly accessible without opening the modal */}
        {docCount > 0 && <CardDocumentsPanel booking={booking} docCount={docCount} />}

        {/* Price + actions */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderTop: "1px solid #E5E7EB", pt: 1.5, mt: 0.5, flexWrap: "wrap", gap: 1 }}>
          <Box>
            <Typography sx={{ fontSize: 12, color: "#6B7280" }}>Offer Price</Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.25 }}>
              <Box sx={{ bgcolor: "#22577A", color: "#fff", fontSize: 15, fontWeight: 700, px: 2, py: 0.5, borderRadius: 2, display: "inline-block" }}>
                ₹{booking.offer_price?.toLocaleString()}
              </Box>
              <Typography sx={{ fontSize: 12, color: "#9CA3AF", textDecoration: "line-through" }}>₹{booking.mrp?.toLocaleString()}</Typography>
              {savings > 0 && (
                <Box sx={{ bgcolor: "#E5FDCF", color: "#059669", fontSize: 11, fontWeight: 700, px: 1, py: 0.25, borderRadius: 4, border: "1px solid #D1FAE5" }}>
                  Save ₹{savings?.toLocaleString()}
                </Box>
              )}
            </Box>
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            {canCancel && (
              <Button variant="outlined" onClick={(e) => { e.stopPropagation(); onCancelRequest(booking); }}
                sx={{ borderColor: "#FECACA", color: "#DC2626", borderRadius: 3, fontWeight: 700, fontSize: 13, px: 2, "&:hover": { bgcolor: "#FEE2E2", borderColor: "#EF4444" } }}>
                Cancel
              </Button>
            )}
            <Button variant="outlined" onClick={() => onView(booking)}
              sx={{ borderColor: "#006D77", bgcolor: "#22577A", color: "#fff", borderRadius: 3, fontWeight: 700, fontSize: 13, px: 2.5, "&:hover": { bgcolor: "#006D77" } }}>
              View Details
            </Button>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

// ─── Main ─────────────────────────────────────────────────────────────────────────
const MyPackageBookings = () => {
  const navigate = useNavigate();
  const [bookings,     setBookings]     = useState([]);
  const [stats,        setStats]        = useState({});
  const [loading,      setLoading]      = useState(true);
  const [refreshing,   setRefreshing]   = useState(false);
  const [error,        setError]        = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [selectedBook, setSelectedBook] = useState(null);
  const [cancelTarget, setCancelTarget] = useState(null);
  const [cancelling,   setCancelling]   = useState(false);

  const filters = [
    { id: "all",       label: "All"       },
    { id: "Pending",   label: "Pending"   },
    { id: "Confirmed", label: "Confirmed" },
    { id: "Collected", label: "Collected" },
    { id: "Completed", label: "Completed" },
    { id: "Cancelled", label: "Cancelled" },
  ];

  const fetchBookings = useCallback(async () => {
    setLoading(true); setError("");
    try {
      const res = await axios.get(`${API}/package-orders/my-bookings`, { headers: getAuthHeader() });
      if (res.data.success) {
        setBookings(res.data.bookings || []);
        setStats(res.data.stats || {});
      } else {
        setError(res.data.error || "Failed to load bookings");
      }
    } catch (e) {
      if (e.response?.status === 401) navigate("/login");
      else setError("Unable to load bookings. Please try again.");
    }
    setLoading(false);
    setRefreshing(false);
  }, [navigate]);

  useEffect(() => { fetchBookings(); }, [fetchBookings]);

  const onRefresh = () => { setRefreshing(true); fetchBookings(); };

  const handleCancel = async (bookingId) => {
    setCancelling(true);
    try {
      const res = await axios.patch(
        `${API}/package-orders/my-bookings/${bookingId}/cancel`,
        {},
        { headers: getAuthHeader() }
      );
      if (res.data.success) {
        setCancelTarget(null); setSelectedBook(null);
        await fetchBookings();
      } else {
        alert(res.data.error || "Cancellation failed");
      }
    } catch (e) {
      alert(e.response?.data?.error || "Cancellation failed");
    }
    setCancelling(false);
  };

  const filtered = filterStatus === "all"
    ? bookings
    : bookings.filter((b) => b.status === filterStatus);

  if (loading && !refreshing) {
    return (
      <ThemeProvider theme={theme}>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "100vh", bgcolor: "#F9FAFB" }}>
          <CircularProgress size={60} sx={{ color: "#006D77" }} />
          <Typography sx={{ mt: 2, fontSize: 16, color: "#6B7280" }}>Loading your bookings...</Typography>
        </Box>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ minHeight: "100vh", bgcolor: "#F9FAFB" }}>

        {/* Header */}
        <Paper elevation={2} sx={{ bgcolor: "#fff", mb: 0 }}>
          <Container maxWidth="lg">
            <Box sx={{ py: { xs: 1.5, sm: 2, md: 3 }, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, position: "relative" }}>
              <IconButton onClick={() => window.history.back()} sx={{ flexShrink: 0, bgcolor: "white", boxShadow: 1, "&:hover": { bgcolor: "#f5f5f5" } }}>
                <ArrowBackIcon />
              </IconButton>
              <Typography variant="h4" sx={{ color: "#006D77", fontWeight: 600, fontSize: { xs: "1rem", sm: "1.4rem", md: "2rem" }, textAlign: "center", flex: 1, fontFamily: "'Sora', sans-serif" }}>
                My Health Bookings
              </Typography>
              <IconButton onClick={onRefresh} disabled={refreshing} sx={{ position: "absolute", right: 0 }}>
                <RefreshIcon />
              </IconButton>
            </Box>
          </Container>
        </Paper>

        {/* Filter chips */}
        <Paper elevation={0} sx={{ bgcolor: "transparent", borderBottom: "1px solid #E5E7EB", py: 1.5 }}>
          <Container maxWidth="lg">
            <Box sx={{ display: "flex", gap: 1, overflowX: "auto", "&::-webkit-scrollbar": { display: "none" } }}>
              {filters.map((filter) => (
                <Chip key={filter.id}
                  label={
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <span>{filter.label}</span>
                      {filter.id !== "all" && (
                        <Box sx={{ bgcolor: "#006D77", color: "#fff", fontSize: 11, fontWeight: 700, px: 0.55, py: 0.55, borderRadius: 1.25, minWidth: 20, textAlign: "center" }}>
                          {bookings.filter((b) => b.status === filter.id).length}
                        </Box>
                      )}
                    </Box>
                  }
                  onClick={() => setFilterStatus(filter.id)}
                  sx={{
                    bgcolor: filterStatus === filter.id ? "#006D77" : "white",
                    color:   filterStatus === filter.id ? "#fff" : "black",
                    fontWeight: 600, fontSize: 14,
                    border: filterStatus === filter.id ? "1px solid white" : "1px solid #006D77",
                    cursor: "pointer",
                    "&:hover": { bgcolor: filterStatus === filter.id ? "#005960" : "#E5E7EB" },
                  }}
                />
              ))}
            </Box>
          </Container>
        </Paper>

        {/* Stats */}
        {bookings.length > 0 && (
          <Container maxWidth="lg" sx={{ py: 2 }}>
            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
              {[
                { label: "Total Bookings", val: bookings.length },
                { label: "Completed",      val: bookings.filter(b => b.status === "Completed").length },
                { label: "Pending",        val: bookings.filter(b => b.status === "Pending").length   },
                { label: "Total Savings",  val: `₹${(stats.total_savings || 0).toLocaleString()}`     },
              ].map((s) => (
                <Paper key={s.label} elevation={1} sx={{ flex: 1, minWidth: 10, bgcolor: "#006D77", p: 2, borderRadius: 3, textAlign: "center" }}>
                  <Typography sx={{ fontSize: 24, fontWeight: 700, color: "#fff", mb: 0.5, fontFamily: "'Sora',sans-serif" }}>{s.val}</Typography>
                  <Typography sx={{ fontSize: 14, color: "#fff" }}>{s.label}</Typography>
                </Paper>
              ))}
            </Box>
          </Container>
        )}

        {/* Booking list */}
        <Container maxWidth="lg" sx={{ py: 2, pb: 6 }}>
          {error && (
            <Box sx={{ textAlign: "center", py: 6 }}>
              <Alert severity="error" sx={{ borderRadius: 2, mb: 2, maxWidth: 420, mx: "auto" }}>{error}</Alert>
              <Button variant="contained" onClick={fetchBookings} sx={{ bgcolor: "#006D77", borderRadius: 2, fontWeight: 700, "&:hover": { bgcolor: "#005960" } }}>
                Try Again
              </Button>
            </Box>
          )}

          {!error && filtered.length === 0 && (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: 10 }}>
              <Typography sx={{ fontSize: 72, mb: 2 }}>🗓️</Typography>
              <Typography sx={{ fontSize: 20, fontWeight: 700, color: "#111827", mb: 1, fontFamily: "'Sora',sans-serif" }}>No Bookings Found</Typography>
              <Typography sx={{ fontSize: 14, color: "#6B7280", textAlign: "center", mb: 3, px: 4 }}>
                {filterStatus === "all" ? "You haven't booked any health packages yet" : `No ${filterStatus} bookings found`}
              </Typography>
              {filterStatus === "all" && (
                <Button variant="contained" onClick={() => navigate("/")} sx={{ bgcolor: "#006D77", color: "#fff", fontWeight: 700, fontSize: 14, px: 3, py: 1.5, "&:hover": { bgcolor: "#005960" } }}>
                  Browse Health Packages
                </Button>
              )}
            </Box>
          )}

          {!error && filtered.map((b) => (
            <BookingCard key={b.id} booking={b} onView={setSelectedBook} onCancelRequest={setCancelTarget} />
          ))}
        </Container>

        {selectedBook && (
          <BookingDetailModal booking={selectedBook} onClose={() => setSelectedBook(null)} onCancelRequest={(b) => setCancelTarget(b)} />
        )}
        {cancelTarget && (
          <CancelDialog booking={cancelTarget} onClose={() => setCancelTarget(null)} onConfirm={handleCancel} loading={cancelling} />
        )}
      </Box>
    </ThemeProvider>
  );
};

export default MyPackageBookings;